var _filter, _clipPath, _filter2, _clipPath2, _filter3, _clipPath3, _filter4, _clipPath4, _filter5, _clipPath5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 1040,
    viewBox: "0 0 740 1040",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 740,
    height: 1040,
    rx: 20,
    fill: "#205A46",
    style: {
      fill: "#205A46",
      fill: "color(display-p3 0.1255 0.3529 0.2745)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 642.723L712.079 642.723",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 966.923L712.079 966.923",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3682 22.6377L86.3681 1017.36",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 534.66L712.079 534.66",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 858.853L712.079 858.853",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.665 22.6377L192.665 1017.36",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 427.483L712.079 427.483",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 751.675L712.079 751.675",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.954 22.6377L298.954 1017.36",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 319.421L712.079 319.421",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.249 22.6377L405.249 1017.36",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 212.233L712.079 212.233",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.548 22.6377L511.548 1017.36",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.452 22.6377L618.452 1017.36",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.832 104.182L712.079 104.182",
    stroke: "#2D7159",
    style: {
      stroke: "#2D7159",
      stroke: "color(display-p3 0.1778 0.4413 0.3505)",
      strokeOpacity: 1
    },
    strokeWidth: 2.15218,
    strokeLinejoin: "round",
    strokeDasharray: "8.61 8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2051 534.482H309.118V675.305C309.118 676.858 308.498 678.348 307.393 679.447C306.289 680.545 304.791 681.162 303.229 681.162H94.0947C92.5327 681.162 91.0346 680.545 89.9301 679.447C88.8256 678.348 88.2051 676.858 88.2051 675.305V534.482Z",
    fill: "#FFE393",
    style: {
      fill: "#FFE393",
      fill: "color(display-p3 1.0000 0.8901 0.5760)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.216 515.5C304.779 515.5 306.278 516.117 307.384 517.215C308.49 518.313 309.113 519.803 309.115 521.357V675.304C309.113 676.859 308.49 678.348 307.384 679.447C306.278 680.545 304.779 681.161 303.216 681.161H94.092C92.53 681.161 91.0319 680.544 89.9274 679.446C88.8229 678.348 88.2023 676.858 88.2023 675.304V521.338C88.2023 519.785 88.8229 518.295 89.9274 517.197C91.0319 516.098 92.53 515.481 94.092 515.481H303.216M303.216 514.08H94.092C92.1587 514.085 90.3061 514.852 88.9399 516.212C87.5737 517.572 86.8052 519.416 86.8027 521.338V675.286C86.8027 677.211 87.5717 679.057 88.9405 680.418C90.3092 681.779 92.1657 682.544 94.1014 682.544H303.216C305.153 682.544 307.01 681.78 308.381 680.419C309.751 679.058 310.522 677.212 310.524 675.286V521.338C310.519 519.413 309.748 517.569 308.378 516.208C307.008 514.848 305.152 514.083 303.216 514.08Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.012 525.553C105.013 526.361 104.774 527.151 104.324 527.824C103.874 528.496 103.234 529.021 102.484 529.331C101.734 529.642 100.908 529.724 100.112 529.568C99.3147 529.411 98.5824 529.023 98.0074 528.453C97.4324 527.882 97.0405 527.155 96.8813 526.363C96.7222 525.57 96.8029 524.749 97.1133 524.003C97.4237 523.256 97.9499 522.618 98.6251 522.169C99.3004 521.72 100.094 521.48 100.907 521.48C101.994 521.48 103.036 521.909 103.806 522.673C104.575 523.436 105.009 524.472 105.012 525.553Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.796 529.616C119.058 529.616 120.891 527.793 120.891 525.544C120.891 523.294 119.058 521.471 116.796 521.471C114.534 521.471 112.7 523.294 112.7 525.544C112.7 527.793 114.534 529.616 116.796 529.616Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2051 534.482H309.118",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.431 608.056C244.182 614.941 244.548 622.068 244.586 629.074C244.624 636.081 245.187 640.705 242.632 647.085C240.321 652.839 235.503 654.801 232.985 660.443C231.698 663.311 226.842 681.153 226.842 681.153H161.586C161.586 681.153 159.708 653.129 169.815 629.187C179.922 605.244 192.462 600.966 192.462 600.966L229.575 591.4L245.431 608.056Z",
    fill: "#FFB000",
    style: {
      fill: "#FFB000",
      fill: "color(display-p3 1.0000 0.6902 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.932 566.226C332.867 563.909 335.572 562.489 337.892 560.555C340.025 558.818 341.65 556.38 343.397 554.269C345.453 551.606 347.365 548.837 349.127 545.973C351.24 543.101 353.642 540.45 356.294 538.061C356.679 537.735 356.998 537.339 357.233 536.893C357.324 536.688 357.369 536.466 357.367 536.242C357.364 536.018 357.314 535.797 357.219 535.593C357.124 535.39 356.986 535.209 356.815 535.063C356.645 534.917 356.444 534.808 356.228 534.745C354.328 534.371 352.358 534.597 350.592 535.389C349.521 535.782 345.895 537.052 345.689 535.034C345.435 532.746 347.361 529.43 348.103 527.281C349.042 524.525 350.047 521.76 350.827 518.939C351.607 516.118 351.4 511.102 349.963 511.018C348.526 510.934 349.606 511.793 349.23 511.952C349.831 511.167 348.789 509.355 347.924 508.822C347.06 508.29 345.942 510.027 345.689 510.971C345.98 510.037 345.163 508.523 344.477 508.467C343.472 508.374 342.692 509.317 342.091 510.093C341.571 510.92 340.903 511.645 340.119 512.232C340.125 511.57 340.026 510.911 339.827 510.28C339.17 509.906 338.418 510.513 337.949 511.074C328.33 522.367 321.82 536.37 311.149 547.244",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.914 533.484C345.914 536.287 345.914 539.043 345.698 541.817",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.931 511.326C348.095 513.951 346.47 516.174 345.249 518.612C343.314 522.499 341.576 526.478 339.782 530.429",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.623 510.812C345.035 512.043 344.363 513.232 343.613 514.372C342.815 515.586 341.932 516.744 341.068 517.931C338.631 521.312 336.434 524.858 334.492 528.543",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.793 512.689C339.062 514.026 338.152 515.258 337.088 516.351C333.956 519.952 331.269 523.913 329.085 528.15",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.861 595.136C222.537 590.279 230.193 585.178 241.747 580.003C252.173 575.333 266.799 571.503 277.075 566.524C291.287 559.63 304.616 552.026 316.292 541.601L337.521 563.815C337.521 563.815 307.547 594.258 297.055 600.19C271.824 614.483 262.638 617.164 236.402 630.802",
    fill: "#FFB000",
    style: {
      fill: "#FFB000",
      fill: "color(display-p3 1.0000 0.6902 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.285 626.982C244.438 621.719 245.636 616.538 247.808 611.736",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22 547.458L330.261 570.952",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.471 659.594C216.376 659.762 225.234 661.154 232.955 665.825C234.687 666.827 236.186 668.182 237.356 669.799C238.526 671.417 239.341 673.261 239.747 675.213C240.604 678.767 240.88 682.435 240.564 686.077C240.55 686.243 240.486 686.402 240.381 686.532C240.275 686.662 240.133 686.757 239.972 686.805C239.534 686.805 239.102 686.699 238.713 686.497C238.713 686.497 239.474 690.066 238.713 690.804C238.15 691.327 237.098 690.617 236.694 690.187C236.271 689.631 235.905 689.033 235.604 688.403C235.604 688.403 236.13 690.458 235.679 690.813C235.022 691.336 233.096 690.01 232.645 688.664C232.363 689.43 231.903 690.131 231.199 689.944C228.972 689.356 227.235 686.208 225.403 684.676C222.97 682.611 219.701 682.471 216.667 682.518C215.27 682.569 213.871 682.541 212.478 682.434C211.094 682.193 209.724 681.881 208.373 681.499C205.759 681.001 203.113 680.689 200.454 680.565",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.945 678.015C226.388 679.024 228.98 680.154 230.352 682.228C230.741 682.856 231.057 683.526 231.291 684.227C231.817 685.675 232.23 687.16 232.634 688.645",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.407 673.605C228.817 674.452 230.134 675.445 231.334 676.567C232.543 677.69 233.472 679.078 234.048 680.621C234.323 681.513 234.527 682.425 234.659 683.349C234.972 685.254 235.285 687.154 235.598 689.047",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.178 670.606C234.501 672.338 236.288 674.685 237.335 677.379C238.154 679.797 238.666 682.308 238.856 684.852L239.138 687.253",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.644 596.857C197.644 596.857 179.224 599.566 172.16 603.611C161.104 609.926 156.248 619.557 149.203 635.905C142.158 652.252 139.302 659.417 139.237 664.863C139.133 672.841 142.74 681.192 157.488 681.192H204.455L213.942 659.156L177.355 653.467L187.453 629.954",
    fill: "#FFB000",
    style: {
      fill: "#FFB000",
      fill: "color(display-p3 1.0000 0.6902 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.006 659.116L177.419 653.418L187.517 629.915",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.429 656.791C164.711 656.791 170.271 653.334 177.42 653.428",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.91 657.548L193.878 681.154",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.227 602.471C226.695 599.894 226.718 597.256 226.292 594.671",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.245 601.844C189.466 606.934 193.549 610.995 198.667 613.203C204.839 615.893 213.218 616.388 219.117 612.792C221.659 611.286 223.693 609.062 224.959 606.402",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.143 611.298C302.163 605.703 312.175 598.329 320.769 589.477",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.663 606.011C316.999 601.901 321.993 597.372 326.599 592.466",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.262 651.082C132.941 658.653 132.115 666.599 132.829 674.482",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.92 652.203C126.449 656.446 125.614 660.881 125.44 665.365",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.831 574.334L193.752 581.041L195.931 588.206L192.944 599.005C192.847 599.343 192.826 599.698 192.883 600.045C192.94 600.393 193.073 600.723 193.273 601.013C195.148 603.726 197.68 605.925 200.635 607.409C203.59 608.893 206.872 609.614 210.181 609.505C220.88 609.505 220.73 602.433 220.73 602.433L222.683 587.403",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.096 573.437C221.325 568.3 219.747 565.124 216.835 561.593C214.374 558.594 210.26 554.353 206.418 553.512C201.449 552.429 196.771 555.988 192.544 558.594C185.593 562.863 185.715 572.064 188.063 578.912C189.867 584.18 193.596 586.189 198.293 589.402C204.436 593.596 217.803 595.493 223.533 590.897C227.825 587.459 227.027 578.874 224.096 573.437Z",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.243 572.98C209.282 573.208 209.255 573.443 209.165 573.657C209.075 573.871 208.927 574.056 208.737 574.19C208.546 574.324 208.322 574.402 208.089 574.415C207.856 574.428 207.625 574.375 207.421 574.263C207.217 574.151 207.048 573.984 206.935 573.781C206.822 573.578 206.769 573.348 206.782 573.116C206.795 572.885 206.873 572.661 207.008 572.472C207.142 572.283 207.328 572.135 207.543 572.046C207.893 571.957 208.263 572.004 208.579 572.178C208.895 572.351 209.132 572.638 209.243 572.98Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.107 567.58C219.136 567.808 219.099 568.04 219.002 568.248C218.905 568.457 218.751 568.635 218.558 568.761C218.365 568.887 218.14 568.958 217.909 568.964C217.678 568.97 217.45 568.911 217.25 568.795C217.051 568.679 216.888 568.509 216.78 568.306C216.672 568.103 216.623 567.873 216.64 567.644C216.656 567.414 216.737 567.194 216.872 567.008C217.008 566.822 217.193 566.677 217.407 566.59C217.764 566.506 218.14 566.562 218.456 566.746C218.773 566.931 219.006 567.229 219.107 567.58Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.824 571.035C214.958 571.966 216.224 572.725 217.582 573.286C218.408 573.66 221.16 574.398 220.55 575.725C219.996 576.557 219.318 577.3 218.54 577.929",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.666 596.26C193.666 596.26 194.924 593.065 195.225 591.916C195.742 589.983 194.107 589.889 193.544 588.18C193.349 587.233 193.401 586.252 193.694 585.331C194.117 583.462 195.093 581.332 194.22 579.427C193.666 578.231 192.473 577.465 191.524 576.54C190.575 575.615 189.796 574.205 190.369 573C191.036 571.589 193.036 571.487 194.257 570.496C195.479 569.506 195.76 567.759 195.676 566.199C195.443 564.654 195.386 563.087 195.507 561.529C195.536 561.248 195.647 560.981 195.826 560.763C196.427 560.146 197.423 560.763 198.175 561.155C198.85 561.497 199.594 561.683 200.352 561.7C201.11 561.716 201.862 561.561 202.552 561.248C202.914 561.117 203.244 560.913 203.524 560.65C203.803 560.386 204.026 560.069 204.177 559.716C204.298 559.257 204.376 558.788 204.412 558.315C204.433 558.078 204.505 557.849 204.621 557.641C204.738 557.434 204.897 557.253 205.088 557.11C205.395 556.954 205.741 556.89 206.084 556.923C207.18 556.974 208.236 557.348 209.118 557.997C209.381 558.284 209.7 558.514 210.055 558.675C210.41 558.835 210.794 558.923 211.184 558.932C212.049 558.77 212.934 558.748 213.805 558.866C214.837 559.304 215.688 560.078 216.219 561.061C217.948 563.553 219.679 566.044 221.414 568.535C222.348 567.337 223.081 565.996 223.584 564.565C223.829 563.848 223.9 563.085 223.791 562.336C223.682 561.587 223.395 560.875 222.954 560.258C222.015 559.118 220.456 558.614 219.667 557.381C218.877 556.148 218.934 554.055 218.84 552.514C218.749 550.805 218.201 549.15 217.252 547.722C216.817 547.011 216.204 546.424 215.473 546.018C214.743 545.612 213.919 545.401 213.082 545.405C212.152 545.623 211.211 545.791 210.264 545.91C209.67 545.864 209.09 545.709 208.554 545.452C206.009 544.368 203.811 542.649 201.284 541.51C198.757 540.37 195.591 540.071 193.403 541.753C192.285 542.612 191.524 543.929 190.331 544.639C186.818 546.713 181.783 542.771 178.439 545.134C176.279 546.638 176.213 549.889 174.391 551.785C172.07 554.205 167.815 553.57 165.204 555.653C162.592 557.736 162.536 561.94 164.133 564.92C164.922 566.395 166.068 567.918 165.73 569.59C165.402 570.58 164.849 571.482 164.114 572.225C163.138 573.372 162.489 574.759 162.236 576.241C162.121 576.977 162.19 577.73 162.435 578.433C162.681 579.137 163.096 579.77 163.645 580.277C164.358 580.875 165.439 581.155 165.983 581.93C166.52 583.004 166.824 584.179 166.876 585.377C166.916 586.282 167.048 587.18 167.27 588.058C168.012 590.422 170.633 591.795 173.113 591.795C174.259 591.795 175.527 591.58 176.466 592.234C177.157 592.883 177.693 593.678 178.035 594.56C178.852 595.867 180.121 596.832 181.604 597.274C183.086 597.716 184.68 597.605 186.085 596.961C187.128 596.438 188.086 595.606 189.241 595.588C190.397 595.569 192.576 596.447 193.666 596.26Z",
    fill: "#2C221D",
    style: {
      fill: "#2C221D",
      fill: "color(display-p3 0.1725 0.1333 0.1137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.855 593.316C212.955 594.082 218.845 594.25 223.307 591.447",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.476 572.719C201.476 569.617 203.523 566.647 206.877 567.235",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.049 565.029C213.048 564.517 213.195 564.015 213.473 563.585C213.752 563.154 214.149 562.812 214.618 562.6C215.074 562.35 215.592 562.23 216.112 562.255C216.633 562.28 217.137 562.448 217.567 562.74",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.117 581.695C197.342 579.537 193.002 580.135 191.602 582.367C188.211 587.72 196.421 594.885 201.437 592.269C202.856 591.531 204.255 589.663 203.588 587.926",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.201 586.376L201.124 586.862",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.897 580.611C196.374 580.436 197.87 580.716 199.181 581.415",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.355 591.402C196.375 592.728 199.118 593.662 201.335 592.448C202.142 592.046 202.788 591.383 203.167 590.569C203.545 589.754 203.635 588.836 203.42 587.964",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.904 578.444C214.453 580.107 215.007 582.284 216.923 582.629C217.643 582.745 218.381 582.608 219.01 582.241C219.639 581.875 220.12 581.302 220.371 580.621",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.01 331.26C352.784 331.259 353.551 331.409 354.267 331.703C354.982 331.997 355.633 332.428 356.181 332.972C356.728 333.516 357.163 334.162 357.46 334.873C357.756 335.584 357.909 336.347 357.909 337.117V452.951C357.906 454.505 357.284 455.995 356.178 457.093C355.072 458.191 353.573 458.808 352.01 458.808H125.977C124.415 458.808 122.917 458.191 121.813 457.093C120.708 455.994 120.088 454.504 120.088 452.951V337.117C120.088 335.563 120.708 334.074 121.813 332.975C122.917 331.877 124.415 331.26 125.977 331.26H352.01ZM352.01 329.859H125.977C124.042 329.859 122.185 330.623 120.816 331.984C119.448 333.346 118.679 335.192 118.679 337.117V452.951C118.679 454.876 119.448 456.722 120.816 458.083C122.185 459.445 124.042 460.209 125.977 460.209H352.01C353.946 460.209 355.804 459.445 357.174 458.084C358.544 456.723 359.315 454.877 359.318 452.951V337.117C359.319 336.162 359.131 335.216 358.764 334.333C358.398 333.45 357.859 332.648 357.181 331.972C356.502 331.296 355.696 330.76 354.809 330.394C353.921 330.028 352.97 329.84 352.01 329.84V329.859Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.088 346.878H357.909V452.922C357.909 454.476 357.289 455.965 356.184 457.064C355.079 458.162 353.581 458.779 352.019 458.779H125.978C124.415 458.779 122.917 458.162 121.813 457.064C120.708 455.965 120.088 454.476 120.088 452.922V346.878Z",
    fill: "#FFE393",
    style: {
      fill: "#FFE393",
      fill: "color(display-p3 1.0000 0.8901 0.5760)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.93 339.526C133.93 340.19 133.732 340.838 133.362 341.39C132.991 341.941 132.464 342.371 131.848 342.625C131.232 342.879 130.554 342.945 129.9 342.816C129.246 342.686 128.645 342.367 128.173 341.898C127.702 341.429 127.38 340.831 127.25 340.181C127.12 339.53 127.187 338.856 127.442 338.243C127.697 337.63 128.13 337.107 128.684 336.738C129.239 336.37 129.891 336.173 130.558 336.173C131.452 336.173 132.31 336.526 132.942 337.155C133.575 337.784 133.93 338.637 133.93 339.526Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.994 339.526C146.994 340.19 146.797 340.838 146.426 341.39C146.056 341.941 145.529 342.371 144.913 342.625C144.297 342.879 143.618 342.945 142.964 342.816C142.31 342.686 141.709 342.367 141.238 341.898C140.766 341.429 140.445 340.831 140.315 340.181C140.185 339.53 140.251 338.856 140.507 338.243C140.762 337.63 141.194 337.107 141.749 336.738C142.303 336.37 142.955 336.173 143.622 336.173C144.517 336.173 145.374 336.526 146.007 337.155C146.639 337.784 146.994 338.637 146.994 339.526Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.088 346.878H357.909",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.886 435.398C258.886 435.398 229.71 410.241 217.198 405.972C204.686 401.703 178.977 408.56 178.686 408.56C178.394 408.56 155.672 458.826 155.672 458.826H248.732L258.886 435.398Z",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.295 503.684C316.424 505.889 318.635 508.012 320.927 510.055C323.134 512.026 325.548 513.792 327.699 515.8C328.235 516.305 328.723 516.846 329.202 517.388C331.034 519.306 332.65 521.418 334.021 523.684C334.171 524.003 334.37 524.297 334.613 524.553C334.731 524.677 334.88 524.77 335.044 524.822C335.208 524.875 335.383 524.885 335.552 524.852C335.723 524.782 335.877 524.676 336.002 524.54C336.127 524.404 336.22 524.243 336.275 524.067C336.805 522.631 336.838 521.06 336.369 519.602C336.125 518.668 335.787 517.734 335.524 516.8C335.218 516.03 335.074 515.207 335.101 514.38C341.348 516.977 346.43 521.676 352.131 525.319C353.296 526.066 355.889 526.337 356.302 525.319C356.875 523.955 348.562 517.846 344.758 513.782C347.721 515.184 350.564 516.825 353.259 518.687C355.035 520.055 357.029 521.119 359.158 521.835C360.36 522.208 363.122 522.769 362.558 520.592C362.339 519.961 361.949 519.401 361.431 518.976C357.673 515.38 353.212 512.839 349.304 509.457C353.7 511.185 357.758 514.277 362.455 514.436C362.917 514.495 363.385 514.393 363.779 514.147C363.912 514.066 364.028 513.959 364.119 513.833C364.21 513.707 364.275 513.564 364.31 513.412C364.345 513.261 364.35 513.104 364.323 512.951C364.296 512.798 364.239 512.652 364.155 512.521C363.746 511.952 363.205 511.49 362.577 511.176C358.19 508.504 353.616 505.571 349.229 502.881C351.55 503.642 353.822 504.547 356.03 505.59C358.25 506.641 360.706 507.105 363.159 506.935C363.939 506.842 364.906 506.337 364.728 505.581C364.595 505.223 364.334 504.927 363.995 504.749L348.026 493.866C346.533 492.848 345.03 491.83 343.499 490.868C341.62 489.709 339.516 488.859 337.797 487.552C336.463 486.543 334.838 485.786 333.401 484.908C329.85 482.741 326.412 480.396 323.068 477.911",
    fill: "#FFCAA3",
    style: {
      fill: "#FFCAA3",
      fill: "color(display-p3 1.0000 0.7922 0.6392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.242 514.343C333.57 513.614 331.86 512.932 330.132 512.315",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.034 513.763C342.758 512.21 340.4 510.779 337.971 509.476",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.345 509.356L343.709 505.815",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.405 504.029C350.012 503.262 348.672 502.404 347.394 501.46",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.945 406.729C235.471 410.334 241.257 410.661 251.562 417.004C262.458 423.777 289.586 452.212 289.586 452.212C289.586 452.212 326.154 477.854 339.859 487.551L315.239 510.904C287.999 494.716 260.063 475.407 239.416 451.427",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.108 453.921C182.108 453.921 193.54 447.821 198.584 446.607C205.554 444.86 213.82 444.365 216.028 445.038C217.07 445.355 220.969 446.953 223.016 449.325C225.186 450.259 226.069 450.736 227.356 451.278C228.643 451.819 229.235 453.323 230.597 454.472C231.959 455.621 233.415 458.826 233.415 458.826C233.415 458.826 223.129 458.826 220.264 458.956C217.399 459.087 214.262 464.561 207.799 466.43",
    fill: "#FFCAA3",
    style: {
      fill: "#FFCAA3",
      fill: "color(display-p3 1.0000 0.7922 0.6392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.659 402.208C197.731 402.143 190.009 400.088 182.1 400.088C167.728 400.088 159.481 407.561 152.492 417.967C147.061 426.266 142.366 435.017 138.458 444.124C134.081 454.212 129.178 465.441 127.9 476.454C127.241 481.499 128.108 486.624 130.389 491.176C134.72 499.453 144.348 500.901 149.965 501.527C155.583 502.153 165.417 500.256 170.246 497.286C185.205 488.119 199.308 477.636 212.384 465.964L185.096 452.054L172.002 457.146L188.534 426.748",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.182 429.251L171.993 457.182",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.094 452.091L161.61 461.152C156.266 463.207 151.034 467.289 146.778 471.082",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.716 455.884L203.99 473.184",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.716 442.348C247.958 448.494 242.792 458.789 242.792 458.789",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.882 480.471L302.444 503.189",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.935 452.212C223.924 452.733 225.944 453.129 227.984 453.398C228.621 453.43 229.244 453.602 229.806 453.903",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.689 449.822C223.332 449.649 222.965 449.499 222.59 449.373C220.667 448.531 218.602 448.059 216.503 447.981",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.304 460.061C218.4 459.333 219.67 458.904 220.986 458.818C223.691 458.538 226.622 459.117 229.186 458.108",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.628 478.444C115.923 483.78 117.657 488.937 120.649 493.376C123.64 497.814 127.779 501.369 132.63 503.666",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.062 477.976C108.279 484.926 111.162 491.661 115.634 495.668",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.996 410.596C270.346 417.626 278.089 425.341 285.141 433.66",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.171 402.264C268.001 406.567 273.326 411.508 278.046 416.995",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82 416.378C190.454 414.673 186.259 412.565 182.289 410.082C180.533 409.147 178.912 407.982 177.47 406.616C176.018 405.233 175.171 403.337 175.112 401.338C175.255 399.506 175.99 397.769 177.207 396.387C180.758 391.941 186.506 389.624 192.236 389.11C197.966 388.596 203.64 389.689 209.201 390.978C217.57 392.94 226.109 395.556 232.553 401.198C234.423 402.735 235.949 404.644 237.033 406.803C238.342 409.885 238.67 413.292 237.973 416.565C237.224 419.83 236.141 423.01 234.741 426.056",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.365 383.516L206.093 386.776L206.337 392.381L200.645 402.04C200.645 402.04 214.105 407.224 219.168 417.789C220.673 418.06 222.226 417.856 223.608 417.206C224.991 416.556 226.135 415.493 226.88 414.165L232.394 401.274",
    fill: "#FFCAA3",
    style: {
      fill: "#FFCAA3",
      fill: "color(display-p3 1.0000 0.7922 0.6392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.867 394.744C244.807 389.195 246.009 383.198 245.915 378.788C245.84 375.052 245.257 369.4 242.834 366.476C239.706 362.74 234.023 362.646 229.242 362.114C221.398 361.245 215.988 368.307 213.658 374.912C211.943 379.85 211.943 385.218 213.658 390.157C215.819 396.985 223.474 406.159 233.431 405.028C238.738 404.431 242.843 400.61 243.867 394.744Z",
    fill: "#FFCAA3",
    style: {
      fill: "#FFCAA3",
      fill: "color(display-p3 1.0000 0.7922 0.6392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.275 382.628C234.172 383.45 233.58 384.057 232.951 383.992C232.615 383.891 232.331 383.667 232.156 383.365C231.981 383.063 231.93 382.705 232.012 382.366C232.106 381.535 232.697 380.928 233.336 381.002C233.671 381.104 233.954 381.329 234.128 381.631C234.303 381.933 234.355 382.289 234.275 382.628Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.103 383.654C245.009 384.476 244.417 385.083 243.778 385.009C243.441 384.911 243.155 384.687 242.98 384.384C242.805 384.081 242.754 383.722 242.839 383.383C242.933 382.561 243.524 381.954 244.163 382.019C244.5 382.122 244.784 382.348 244.959 382.652C245.134 382.955 245.185 383.314 245.103 383.654Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.287 381.825C240.165 383.745 240.165 385.67 240.287 387.589C240.287 388.775 240.287 390.868 238.784 391.139C237.691 391.158 236.602 391.013 235.553 390.709",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.378 394.1L232.311 390.699C232.311 390.699 229.324 394.576 230.864 395.986C233.335 398.256 236.378 394.1 236.378 394.1Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.972 367.654C244.766 370.456 245.79 372.689 245.837 381.059C246.705 380.887 247.546 380.598 248.335 380.199C248.73 380 249.081 379.725 249.368 379.39C249.655 379.055 249.872 378.666 250.007 378.247C250.43 376.668 249.246 375.108 249.181 373.483C249.215 372.297 249.611 371.15 250.317 370.195C250.889 369.485 251.297 368.659 251.51 367.775C251.53 367.135 251.396 366.5 251.12 365.922C250.844 365.344 250.434 364.839 249.923 364.45C247.8 362.581 244.963 361.769 242.521 360.367C241.337 359.685 240.708 358.621 239.609 357.817C238.374 356.91 237.052 356.124 235.664 355.472C232.451 353.963 228.966 353.115 225.415 352.978C222.03 352.829 218.65 353.375 215.487 354.584C212.324 355.793 209.446 357.638 207.033 360.003C200.711 366.299 198.175 378.303 202.139 385.225C204.374 389.139 206.422 392.362 206.422 392.362C206.685 392.764 212.143 387.887 212.481 387.224C212.774 386.527 213 385.805 213.157 385.066C213.862 382.6 216.332 382.189 218.446 381.423C221.527 380.293 223.067 377.565 223.668 374.482C223.966 372.701 224.114 370.898 224.11 369.092C224.11 369.494 226.599 370.372 226.928 370.484C230.677 371.656 234.68 371.769 238.491 370.811C239.634 370.579 240.71 370.094 241.638 369.391C241.901 369.223 243.366 368.055 242.972 367.654Z",
    fill: "#1E1611",
    style: {
      fill: "#1E1611",
      fill: "color(display-p3 0.1176 0.0863 0.0667)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.011 400.077C223.164 403.035 227.25 404.817 231.574 405.122",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.703 376.762C228.04 376.115 228.53 375.559 229.131 375.141C229.732 374.724 230.426 374.458 231.153 374.366C231.88 374.274 232.619 374.359 233.305 374.614C233.992 374.868 234.607 375.285 235.096 375.828",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.47 376.939C241.646 376.441 241.979 376.013 242.418 375.717C242.858 375.421 243.382 375.273 243.912 375.295C244.41 375.446 244.844 375.757 245.145 376.18C245.446 376.603 245.597 377.113 245.575 377.63",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.159 384.748C237.944 385.41 237.599 386.023 237.144 386.551C236.688 387.078 236.131 387.51 235.506 387.821C234.88 388.131 234.198 388.315 233.501 388.36C232.803 388.405 232.103 388.311 231.442 388.083C230.101 387.594 229.007 386.6 228.395 385.315C227.784 384.031 227.704 382.559 228.173 381.217C228.389 380.556 228.734 379.944 229.19 379.417C229.646 378.89 230.203 378.459 230.828 378.149C231.453 377.838 232.134 377.655 232.832 377.609C233.529 377.563 234.229 377.656 234.89 377.882C236.231 378.372 237.325 379.366 237.937 380.65C238.548 381.934 238.628 383.406 238.159 384.748Z",
    stroke: "#572A2F",
    style: {
      stroke: "#572A2F",
      stroke: "color(display-p3 0.3412 0.1647 0.1843)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28 386.066C247.763 388.99 245.866 391.092 244.043 390.737C242.221 390.382 241.141 387.757 241.658 384.833C242.174 381.909 244.062 379.807 245.894 380.162C247.726 380.517 248.787 383.142 248.28 386.066Z",
    stroke: "#572A2F",
    style: {
      stroke: "#572A2F",
      stroke: "color(display-p3 0.3412 0.1647 0.1843)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.142 383.31L238.432 382.619",
    stroke: "#572A2F",
    style: {
      stroke: "#572A2F",
      stroke: "color(display-p3 0.3412 0.1647 0.1843)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.386 380.713L217.198 381.563",
    stroke: "#572A2F",
    style: {
      stroke: "#572A2F",
      stroke: "color(display-p3 0.3412 0.1647 0.1843)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.405 383.571C220.349 380.871 216.648 378.76 214.281 379.619C208.494 381.684 210.448 391.997 215.821 392.977C217.343 393.258 219.522 392.669 220.067 390.95",
    fill: "#FFCAA3",
    style: {
      fill: "#FFCAA3",
      fill: "color(display-p3 1.0000 0.7922 0.6392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.853 384.217L218.831 388.691",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.846 380.283C219.09 381.021 220.075 382.124 220.664 383.441",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.97 388.121C211.712 390.326 213.234 392.661 215.666 393.053C216.521 393.227 217.411 393.107 218.187 392.711C218.964 392.315 219.583 391.668 219.94 390.877",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.193 372.95C198.22 369.315 198.793 365.703 199.894 362.236C201.013 358.756 203.144 355.684 206.018 353.408C207.668 352.255 209.457 351.313 211.344 350.606C212.911 349.945 214.533 349.419 216.191 349.036C222.419 347.719 228.881 349.681 234.715 352.212",
    fill: "#FF8A6C",
    style: {
      fill: "#FF8A6C",
      fill: "color(display-p3 1.0000 0.5412 0.4235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.506 352.69C234.922 350.413 231.562 349.203 228.112 349.308C227.453 349.345 226.796 349.43 226.149 349.56C221.631 350.494 217.554 352.802 213.646 355.165C208.414 358.379 203.192 361.844 199.359 366.627C197.859 368.272 196.905 370.337 196.626 372.54C196.597 373.767 196.805 374.987 197.236 376.137C198.102 378.415 199.319 380.545 200.843 382.452C212.341 371.756 225.266 363.292 240.173 358.267C240.028 356.138 239.074 354.145 237.506 352.69Z",
    fill: "#FF8A6C",
    style: {
      fill: "#FF8A6C",
      fill: "color(display-p3 1.0000 0.5412 0.4235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.95 367.205C205.993 358.398 215.72 352.104 226.67 349.27L198.95 367.205Z",
    fill: "#FF8A6C",
    style: {
      fill: "#FF8A6C",
      fill: "color(display-p3 1.0000 0.5412 0.4235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.95 367.205C205.993 358.398 215.72 352.104 226.67 349.27",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.991 368.746C205.282 371.263 206.966 373.562 208.979 375.556",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.328 358.63C216.808 361.725 218.633 364.645 220.767 367.336",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.365 352.193C229.849 354.745 231.964 357.628 233.649 360.759",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.518 350.736C233.67 353.419 235.481 356.356 236.909 359.48",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.346 370.25C199.091 374.016 201.175 377.388 204.217 379.75",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.705 398.471C197.2 400.516 202.752 402.581 207.674 405.804C212.596 409.027 217.518 413.557 219.265 419.125",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.006 417.434C225.546 416.226 227.552 414.131 228.642 411.549",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.099 400.751C177.644 415.268 196.901 412.493 205.871 416.996",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.183 411.297C237.909 413.315 237.087 415.22 235.806 416.808C233.815 419.116 230.706 420.069 227.766 420.909",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.423 417.434C231.757 426.56 233.109 436.789 232.687 446.009",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.022 415.332C211.413 419.125 210.755 429.41 210.605 438.686",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.804 375.174H603.942V478.145C603.942 479.698 603.322 481.188 602.217 482.286C601.113 483.385 599.615 484.002 598.053 484.002H388.693C387.131 484.002 385.633 483.385 384.529 482.286C383.424 481.188 382.804 479.698 382.804 478.145V375.174Z",
    fill: "#A1E2CE",
    style: {
      fill: "#A1E2CE",
      fill: "color(display-p3 0.6306 0.8875 0.8062)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.069 359.554C599.631 359.554 601.129 360.171 602.234 361.269C603.338 362.367 603.959 363.857 603.959 365.411V478.106C603.959 479.659 603.338 481.149 602.234 482.248C601.129 483.346 599.631 483.963 598.069 483.963H388.691C387.129 483.963 385.631 483.346 384.527 482.248C383.422 481.149 382.802 479.659 382.802 478.106V365.411C382.802 363.857 383.422 362.367 384.527 361.269C385.631 360.171 387.129 359.554 388.691 359.554H598.069ZM598.069 358.152H388.691C386.756 358.155 384.901 358.92 383.533 360.281C382.165 361.642 381.395 363.486 381.393 365.411V478.106C381.395 480.03 382.165 481.875 383.533 483.236C384.901 484.596 386.756 485.362 388.691 485.364H598.069C600.004 485.362 601.859 484.596 603.227 483.236C604.596 481.875 605.365 480.03 605.368 478.106V365.411C605.365 363.486 604.596 361.642 603.227 360.281C601.859 358.92 600.004 358.155 598.069 358.152Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.255 364.47C393.922 364.468 394.575 364.663 395.131 365.03C395.687 365.398 396.12 365.921 396.377 366.533C396.634 367.146 396.702 367.821 396.573 368.472C396.444 369.123 396.123 369.721 395.652 370.191C395.181 370.661 394.58 370.981 393.926 371.112C393.271 371.242 392.593 371.176 391.976 370.922C391.359 370.669 390.832 370.239 390.461 369.687C390.09 369.136 389.892 368.487 389.892 367.823C389.892 366.935 390.246 366.084 390.876 365.455C391.507 364.826 392.362 364.472 393.255 364.47ZM393.255 363.068C392.309 363.068 391.385 363.347 390.599 363.87C389.812 364.392 389.199 365.135 388.838 366.004C388.476 366.872 388.381 367.828 388.566 368.751C388.75 369.673 389.205 370.52 389.874 371.185C390.543 371.85 391.395 372.303 392.322 372.487C393.25 372.67 394.211 372.576 395.085 372.216C395.958 371.856 396.705 371.247 397.23 370.465C397.756 369.683 398.036 368.764 398.036 367.823C398.034 366.563 397.529 365.355 396.633 364.464C395.737 363.573 394.522 363.071 393.255 363.068Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.334 364.47C407.001 364.47 407.653 364.666 408.207 365.035C408.762 365.403 409.194 365.927 409.449 366.54C409.704 367.153 409.771 367.827 409.641 368.477C409.511 369.128 409.19 369.726 408.718 370.195C408.246 370.664 407.646 370.983 406.991 371.112C406.337 371.242 405.659 371.175 405.043 370.921C404.427 370.668 403.9 370.238 403.53 369.686C403.159 369.135 402.961 368.486 402.961 367.823C402.96 367.382 403.047 366.946 403.216 366.538C403.385 366.131 403.633 365.761 403.946 365.449C404.26 365.137 404.632 364.89 405.042 364.722C405.451 364.554 405.89 364.468 406.334 364.47ZM406.334 363.068C405.388 363.067 404.462 363.344 403.675 363.865C402.887 364.386 402.273 365.128 401.91 365.997C401.546 366.866 401.45 367.822 401.634 368.745C401.817 369.668 402.272 370.516 402.94 371.182C403.608 371.848 404.46 372.302 405.388 372.486C406.316 372.67 407.277 372.577 408.152 372.217C409.026 371.857 409.773 371.248 410.299 370.466C410.825 369.684 411.105 368.764 411.105 367.823C411.103 366.564 410.6 365.358 409.706 364.467C408.812 363.576 407.599 363.073 406.334 363.068Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.804 375.174H603.961",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.945 476.248L530.903 365.626L514.408 364.664L501.455 375.173L468.137 399.265L505.597 508.429L588.945 476.248Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9 397.679C481.534 399.013 483.449 399.964 485.503 400.462C487.556 400.96 489.696 400.992 491.764 400.556",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.817 399.265C499.909 397.901 503.454 395.269 505.932 391.756C508.41 388.242 509.691 384.032 509.588 379.741",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.11 435.118C563.059 416.08 532.925 356.052 524.979 359.013C515.858 362.404 505.591 371.157 505.591 371.157C505.591 371.157 510.513 386.804 510.889 388.28C512.248 393.698 513.653 399.097 515.106 404.478C518.704 417.892 521.916 431.512 526.378 444.646C530.896 458.014 535.903 471.241 541.295 484.291C543.465 489.523 545.203 495.651 549.317 499.742C551.646 502.105 554.953 503.759 558.231 503.479C560.511 503.119 562.7 502.323 564.675 501.134C573.636 496.463 598.632 485.319 598.632 485.319C598.632 485.319 585.773 459.144 573.11 435.118Z",
    fill: "#4C4139",
    style: {
      fill: "#4C4139",
      fill: "color(display-p3 0.2980 0.2549 0.2235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.906 508.317C519.464 499.48 515.284 491.344 512.193 482.75C508.145 471.54 504.547 460.116 500.367 448.915C493.998 431.83 484.962 408.214 478.048 391.344C478.048 391.344 465.367 398.574 462.812 400.33C460.257 402.086 460.811 406.262 460.811 406.262C470.909 443.684 501.466 528.682 501.466 528.682C505.092 526.814 514.062 521.769 517.679 519.864C522.451 517.36 523.277 513.287 521.906 508.317Z",
    fill: "#4C4139",
    style: {
      fill: "#4C4139",
      fill: "color(display-p3 0.2980 0.2549 0.2235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.348 398.761C477.071 416.668 486.192 431.241 498.412 448.822",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.503 363.535C523.933 387.294 525.414 411.117 525.946 435.007",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.842 490.336C397.388 492.204 394.883 493.967 392.328 495.623C389.848 497.23 387.18 498.594 384.747 500.294C384.137 500.705 383.583 501.172 383.019 501.63C380.909 503.243 378.985 505.082 377.28 507.113C377.079 507.406 376.835 507.668 376.556 507.889C376.414 507.994 376.248 508.063 376.072 508.087C375.896 508.112 375.717 508.092 375.551 508.029C375.39 507.925 375.254 507.788 375.151 507.627C375.049 507.465 374.984 507.284 374.959 507.095C374.664 505.592 374.879 504.035 375.57 502.667C375.955 501.733 376.425 500.911 376.838 500.023C377.259 499.306 377.527 498.512 377.627 497.688C371.052 499.294 365.303 503.162 359.103 505.89C357.835 506.441 355.252 506.329 354.98 505.245C354.632 503.816 363.791 499.042 368.187 495.623C365.038 496.552 361.972 497.736 359.019 499.164C357.049 500.24 354.913 500.982 352.697 501.359C351.457 501.555 348.639 501.686 349.532 499.612C349.853 499.025 350.326 498.535 350.903 498.192C355.139 495.212 359.977 493.4 364.364 490.644C359.742 491.681 355.271 494.119 350.574 493.549C350.11 493.54 349.665 493.368 349.316 493.064C349.198 492.963 349.101 492.839 349.031 492.701C348.961 492.563 348.919 492.412 348.907 492.258C348.896 492.103 348.916 491.948 348.965 491.801C349.014 491.654 349.091 491.518 349.193 491.401C349.683 490.898 350.29 490.523 350.959 490.308C355.712 488.337 360.691 486.123 365.444 484.161C363.019 484.572 360.622 485.133 358.267 485.843C355.911 486.539 353.413 486.62 351.016 486.076C350.255 485.861 349.381 485.217 349.673 484.498C349.858 484.163 350.163 483.91 350.527 483.788L368.027 475.492C369.671 474.717 371.305 473.942 372.968 473.222C376.584 471.681 380.079 469.906 383.705 468.365C387.506 466.739 391.332 465.167 395.183 463.647",
    fill: "#D16159",
    style: {
      fill: "#D16159",
      fill: "color(display-p3 0.8196 0.3804 0.3490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.488 497.659C379.264 497.192 381.058 496.781 382.861 496.444",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.912 495.575C370.404 494.395 372.957 493.344 375.558 492.427",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.336 490.569L370.432 487.935",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.128 484.983C364.626 484.445 366.086 483.805 367.496 483.068",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.816 400.331C458.695 402.93 454.874 405.972 451.422 409.402C447.007 414.184 421.015 445.506 421.015 445.506C421.015 445.506 394.394 461.471 379.14 470.289L395.841 497.314C395.841 497.314 426.764 486.254 442.545 475.24C456.879 465.217 484.327 432.4 484.327 432.4",
    fill: "#4C4139",
    style: {
      fill: "#4C4139",
      fill: "color(display-p3 0.2980 0.2549 0.2235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.691 445.507L465.331 419.649",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.185 462.067L411.689 490.662",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91 489.345L406.268 482.273",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.183 481.928C401.221 482.264 401.122 482.601 400.91 482.864C400.698 483.128 400.389 483.297 400.051 483.334C399.714 483.371 399.375 483.274 399.11 483.063C398.845 482.851 398.675 482.544 398.638 482.209C398.619 482.042 398.634 481.874 398.681 481.713C398.727 481.553 398.806 481.403 398.911 481.272C399.016 481.142 399.146 481.033 399.293 480.953C399.441 480.872 399.602 480.821 399.77 480.803C399.937 480.784 400.106 480.799 400.267 480.845C400.429 480.892 400.58 480.97 400.711 481.074C400.842 481.179 400.951 481.308 401.032 481.455C401.114 481.601 401.165 481.762 401.183 481.928Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.687 485.309C394.398 485.309 394.974 484.736 394.974 484.029C394.974 483.322 394.398 482.749 393.687 482.749C392.977 482.749 392.4 483.322 392.4 484.029C392.4 484.736 392.977 485.309 393.687 485.309Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.836 445.899L420.771 445.376C424.321 444.324 427.693 442.75 430.774 440.705",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.358 415.428C438.405 409.384 444.528 404.317 451.422 400.481",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.409 401.675C442.178 398.147 447.372 395.225 452.871 392.979",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.32 352.493L492.077 363.441L505.341 376.192C505.341 376.192 505.688 383.787 498.183 391.746C490.678 399.705 482.675 394.343 482.675 394.343L473.009 380.284",
    fill: "#D16159",
    style: {
      fill: "#D16159",
      fill: "color(display-p3 0.8196 0.3804 0.3490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.275 381.021C455.753 376.163 453.828 365.673 453.978 361.684C454.002 358.278 455.195 354.982 457.36 352.342C460.243 348.979 467.016 350.184 471.346 349.773C478.457 349.101 482.891 357.48 484.901 363.477C486.432 368.092 487.165 372.819 485.596 377.546C483.041 385.196 474.841 392.922 466.161 390.839C461.446 389.736 458.778 385.729 457.275 381.021Z",
    fill: "#D16159",
    style: {
      fill: "#D16159",
      fill: "color(display-p3 0.8196 0.3804 0.3490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.035 351.119C493.889 349.905 492.33 348.962 491.823 347.383C491.541 346.514 491.099 343.889 490.817 343.011C489.23 338.135 485.116 336.472 480.485 337.303C479.978 332.633 475.008 332.194 470.922 332.147C469.213 332.213 467.512 331.87 465.963 331.147C464.347 330.288 462.891 329.083 461.003 328.896C459.301 328.789 457.612 329.249 456.203 330.204C451.356 333.371 449.975 339.499 443.992 341.348C442.113 341.937 440.159 342.114 438.543 343.329C437.933 343.77 437.417 344.328 437.025 344.969C436.634 345.611 436.374 346.323 436.261 347.065C436.017 349.204 437.444 350.503 438.91 351.811C439.762 352.504 440.439 353.387 440.886 354.388C441.333 355.389 441.537 356.48 441.484 357.574C441.325 358.967 441.096 360.352 440.798 361.722C440.416 363.596 440.584 365.54 441.284 367.321C441.984 369.102 443.185 370.644 444.743 371.764C445.438 372.268 446.387 372.698 448.951 373.296C450.755 373.688 455.433 373.016 455.433 373.016C454.879 369.926 454.503 366.807 454.305 363.674C454.317 361.246 455.103 358.885 456.55 356.93C457.8 355.239 460.524 354.641 462.553 354.735C465.587 354.865 468.489 356.528 471.514 356.182C472.771 356.022 473.958 355.517 474.943 354.725C479.01 357.341 483.218 361.19 484.148 365.879C484.148 366.112 484.787 368.887 484.58 368.934C488.065 368.205 492.452 367.925 493.974 364.141C494.509 362.834 494.237 361.47 494.65 360.143C494.988 359.05 495.974 358.275 496.435 357.191C497.365 355.202 496.557 352.736 495.035 351.119Z",
    fill: "#2C221D",
    style: {
      fill: "#2C221D",
      fill: "color(display-p3 0.1725 0.1333 0.1137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.554 365.337C480.732 362.32 484.922 360.115 487.571 361.18C493.958 363.74 491.328 375.192 485.269 376.061C483.55 376.304 481.136 375.547 480.573 373.604",
    fill: "#D16159",
    style: {
      fill: "#D16159",
      fill: "color(display-p3 0.8196 0.3804 0.3490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.845 366.346L482.087 371.138",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.561 361.731C482.151 362.51 481.017 363.7 480.311 365.141",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.902 370.839C489.962 373.277 488.168 375.818 485.454 376.154C484.488 376.314 483.497 376.143 482.643 375.667C481.789 375.192 481.124 374.441 480.757 373.539",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.408 388.168C480.643 386.559 482.417 384.399 483.556 381.899",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.448 369.429C462.739 372.11 463.031 374.8 463.341 377.49C463.345 377.865 463.47 378.228 463.698 378.527C464.712 379.602 467.051 379.088 468.141 378.443",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.69 379.547L465.993 382.265C465.993 382.265 467.806 385.712 469.619 385.068C473.01 383.779 470.69 379.547 470.69 379.547Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.825 363.618C465.091 363.14 465.449 362.72 465.88 362.382C466.31 362.043 466.805 361.793 467.333 361.647C468.217 361.369 469.151 361.29 470.07 361.416C470.988 361.542 471.866 361.87 472.64 362.376",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.914 367.514C453.988 367.058 454.154 366.622 454.403 366.232C454.652 365.841 454.977 365.506 455.361 365.244C455.95 364.856 456.641 364.649 457.347 364.649C458.054 364.649 458.745 364.856 459.334 365.244",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.987 367.625C470.98 367.903 470.895 368.173 470.742 368.405C470.589 368.638 470.373 368.823 470.12 368.941C469.867 369.059 469.586 369.104 469.308 369.071C469.031 369.038 468.768 368.93 468.549 368.757C468.33 368.584 468.164 368.353 468.07 368.092C467.975 367.83 467.956 367.548 468.014 367.276C468.072 367.004 468.205 366.754 468.399 366.553C468.592 366.352 468.838 366.209 469.108 366.14C469.554 366.095 470 366.225 470.351 366.502C470.702 366.78 470.93 367.183 470.987 367.625Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.235 370.811C460.228 371.089 460.143 371.359 459.99 371.592C459.837 371.824 459.621 372.01 459.368 372.127C459.115 372.245 458.834 372.29 458.556 372.257C458.279 372.225 458.016 372.116 457.797 371.943C457.578 371.77 457.412 371.54 457.318 371.278C457.224 371.017 457.204 370.734 457.262 370.462C457.32 370.191 457.453 369.94 457.647 369.74C457.84 369.539 458.086 369.396 458.356 369.326C458.803 369.276 459.252 369.404 459.604 369.683C459.956 369.961 460.183 370.367 460.235 370.811Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.398 356.069C455.387 357.144 454.514 359.488 453.152 361.31C452.036 362.779 450.562 363.942 448.869 364.689C447.177 365.436 445.321 365.742 443.477 365.579",
    stroke: "#635149",
    style: {
      stroke: "#635149",
      stroke: "color(display-p3 0.3882 0.3176 0.2863)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.291 354.491C477.122 352.805 478.41 350.617 478.992 348.204",
    stroke: "#635149",
    style: {
      stroke: "#635149",
      stroke: "color(display-p3 0.3882 0.3176 0.2863)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.417 477.313C496.417 477.976 496.219 478.624 495.849 479.176C495.478 479.727 494.952 480.157 494.336 480.411C493.719 480.665 493.041 480.731 492.387 480.602C491.733 480.472 491.132 480.153 490.661 479.684C490.189 479.215 489.868 478.617 489.738 477.967C489.608 477.316 489.674 476.642 489.93 476.029C490.185 475.416 490.617 474.893 491.172 474.524C491.726 474.156 492.378 473.959 493.045 473.959C493.939 473.959 494.797 474.312 495.43 474.941C496.062 475.57 496.417 476.423 496.417 477.313Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.501 477.313C509.501 477.976 509.303 478.624 508.933 479.176C508.562 479.727 508.036 480.157 507.42 480.411C506.803 480.665 506.125 480.731 505.471 480.602C504.817 480.472 504.216 480.153 503.745 479.684C503.273 479.215 502.952 478.617 502.822 477.967C502.692 477.316 502.758 476.642 503.014 476.029C503.269 475.416 503.701 474.893 504.256 474.524C504.81 474.156 505.462 473.959 506.129 473.959C507.023 473.959 507.881 474.312 508.514 474.941C509.146 475.57 509.501 476.423 509.501 477.313Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.593 484.666H651.795",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.936 521.929C368.476 524.276 369.569 526.885 370.157 529.626",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.588 581.125C565.224 585.459 578.976 599.089 578.976 599.089",
    stroke: "#6D574E",
    style: {
      stroke: "#6D574E",
      stroke: "color(display-p3 0.4275 0.3412 0.3059)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.502 495.677C566.935 494.222 566.049 492.91 564.909 491.838C560.87 488.101 552.05 488.372 549.034 493.407C547.372 496.21 548.18 499.731 549.438 502.693L551.918 508.101C553.659 509.024 555.595 509.524 557.567 509.559C559.539 509.595 561.492 509.166 563.265 508.307C564.729 507.647 565.983 506.602 566.894 505.285C567.804 503.968 568.336 502.429 568.432 500.834C568.489 499.069 568.172 497.312 567.502 495.677Z",
    fill: "#893D33",
    style: {
      fill: "#893D33",
      fill: "color(display-p3 0.5373 0.2392 0.2000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.255 445.468C520.255 445.468 510.476 449.924 503.91 452.885C500.2 454.557 493.972 459.134 491.849 462.619C489.144 467.056 488.44 472.539 488.75 477.061C489.175 480.512 490.407 483.817 492.347 486.71C493.681 488.868 495.099 491.11 496.33 490.821C497.56 490.531 497.128 487.514 497.128 487.514C497.61 488.665 498.214 489.761 498.932 490.783C499.383 491.082 499.871 491.353 500.378 491.11C500.979 490.838 501.464 490.365 501.75 489.774C501.969 489.227 502.08 488.644 502.079 488.055C502.121 487.243 502.121 486.43 502.079 485.617C502.351 486.225 502.614 488.112 503.131 488.009C503.836 487.832 504.474 487.452 504.962 486.916C505.81 485.766 506.446 484.475 506.841 483.105C506.827 483.421 506.871 483.738 506.973 484.039C507.03 484.19 507.126 484.323 507.252 484.427C507.377 484.53 507.527 484.599 507.687 484.627C508.561 484.291 509.355 483.776 510.016 483.114C511.068 481.685 511.463 479.788 512.224 478.191C512.806 476.963 513.535 475.809 514.393 474.753C515.294 473.584 516.405 472.593 517.672 471.829C520.152 470.531 521.683 470.185 524.247 469.027C526.449 468.109 528.407 466.696 529.968 464.898",
    fill: "#D16159",
    style: {
      fill: "#D16159",
      fill: "color(display-p3 0.8196 0.3804 0.3490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.561 483.666C506.758 481.536 507.011 479.416 507.35 477.314C507.525 475.9 507.875 474.513 508.392 473.185C509.456 471.099 510.898 469.227 512.647 467.664",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.286 486.093C501.61 482.511 501.392 478.857 501.638 475.22C501.631 474.213 501.729 473.208 501.929 472.221C502.457 470.56 503.292 469.011 504.39 467.653",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.232 488.214C495.951 484.73 495.072 481.114 494.611 477.434C494.55 476.725 494.531 476.014 494.555 475.304C494.693 472.643 495.473 470.054 496.828 467.756",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.575 392.745L545.784 425.029L507.384 451.185L532.661 470.979C532.661 470.979 575.739 457.033 587.481 450.111C596.687 444.674 600.632 430.568 582.897 407.56C565.162 384.552 552.895 370.895 549.25 367.065C541.444 358.798 532.098 355.36 523.409 359.732",
    fill: "#4C4139",
    style: {
      fill: "#4C4139",
      fill: "color(display-p3 0.2980 0.2549 0.2235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.582 392.746L545.781 425.03L507.391 451.177",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.563 462.069C529.565 462.323 529.491 462.571 529.351 462.783C529.21 462.994 529.01 463.16 528.775 463.258C528.54 463.357 528.281 463.383 528.031 463.335C527.781 463.287 527.55 463.165 527.37 462.987C527.189 462.808 527.065 462.58 527.015 462.332C526.964 462.083 526.989 461.825 527.086 461.591C527.183 461.357 527.348 461.156 527.56 461.015C527.772 460.874 528.021 460.799 528.276 460.799C528.616 460.799 528.942 460.932 529.183 461.17C529.424 461.408 529.561 461.731 529.563 462.069Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.211 459.369C536.921 459.369 537.498 458.796 537.498 458.089C537.498 457.383 536.921 456.81 536.211 456.81C535.5 456.81 534.924 457.383 534.924 458.089C534.924 458.796 535.5 459.369 536.211 459.369Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.935 461.789C521.075 461.901 537.486 453.681 537.486 453.681",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.84 441.33C522 441.217 551.344 464.683 551.344 464.683",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.836 425.347C548.443 423.955 552.059 422.442 555.911 421.872C560.039 421.391 564.206 421.325 568.348 421.676",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.655 470.961L582.384 452.988",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.716 594.314C550.278 594.314 551.776 594.931 552.881 596.03C553.986 597.128 554.606 598.618 554.606 600.171V703.862C554.606 705.415 553.986 706.905 552.881 708.003C551.776 709.102 550.278 709.719 548.716 709.719H379.767C378.994 709.72 378.227 709.569 377.512 709.275C376.797 708.981 376.147 708.55 375.6 708.006C375.053 707.462 374.619 706.816 374.324 706.104C374.028 705.393 373.877 704.631 373.878 703.862V600.171C373.878 598.618 374.498 597.128 375.603 596.03C376.707 594.931 378.205 594.314 379.767 594.314H548.716ZM548.716 592.913H379.767C377.832 592.916 375.977 593.681 374.609 595.042C373.241 596.402 372.471 598.247 372.469 600.171V703.862C372.469 705.787 373.238 707.633 374.606 708.994C375.975 710.355 377.832 711.12 379.767 711.12H548.716C550.651 711.117 552.506 710.352 553.875 708.991C555.243 707.631 556.013 705.786 556.015 703.862V600.171C556.013 598.247 555.243 596.402 553.875 595.042C552.506 593.681 550.651 592.916 548.716 592.913Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.879 609.934H554.607V703.899C554.607 705.453 553.987 706.943 552.882 708.041C551.778 709.139 550.28 709.756 548.718 709.756H379.769C378.207 709.756 376.708 709.139 375.604 708.041C374.499 706.943 373.879 705.453 373.879 703.899V609.934Z",
    fill: "#A1E2CE",
    style: {
      fill: "#A1E2CE",
      fill: "color(display-p3 0.6306 0.8875 0.8062)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.705 602.609C387.705 603.273 387.508 603.921 387.137 604.473C386.767 605.024 386.24 605.454 385.624 605.708C385.007 605.962 384.329 606.028 383.675 605.899C383.021 605.769 382.42 605.45 381.949 604.981C381.477 604.512 381.156 603.914 381.026 603.264C380.896 602.613 380.962 601.939 381.218 601.326C381.473 600.713 381.905 600.19 382.46 599.821C383.014 599.453 383.666 599.256 384.333 599.256C385.228 599.256 386.085 599.609 386.718 600.238C387.35 600.867 387.705 601.72 387.705 602.609Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.776 602.609C400.776 603.273 400.578 603.922 400.207 604.474C399.836 605.025 399.309 605.455 398.692 605.709C398.075 605.962 397.397 606.028 396.742 605.898C396.088 605.768 395.487 605.447 395.016 604.977C394.544 604.508 394.224 603.909 394.095 603.258C393.966 602.607 394.034 601.932 394.291 601.32C394.547 600.707 394.981 600.184 395.537 599.817C396.093 599.449 396.746 599.254 397.413 599.256C397.855 599.256 398.293 599.343 398.702 599.511C399.111 599.68 399.482 599.927 399.794 600.239C400.106 600.55 400.354 600.92 400.522 601.327C400.691 601.734 400.777 602.169 400.776 602.609Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.879 609.934H554.607",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.40122,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.585 581.565C350.485 576.25 345.581 565.974 344.21 560.5C342.998 555.68 341.918 550.747 339.626 546.291C339.006 545.086 336.357 542.312 337.325 540.873C339.26 537.968 343.966 541.808 345.187 543.526C345.628 544.143 347.244 546.749 348.052 546.908C348.86 547.067 349.207 543.937 349.311 542.592C349.719 537.275 349.719 531.935 349.311 526.618C348.86 521.256 349.63 516.548 351.321 516.343C353.012 516.137 352.946 517.109 353.256 517.445C353.528 515.745 355.087 513.708 356.074 514.297C356.358 514.504 356.591 514.774 356.753 515.085C356.916 515.396 357.005 515.74 357.013 516.091C357.134 516.773 357.301 517.447 357.511 518.108C357.511 518.108 358.45 514.484 360.263 516.539C361.156 517.566 362.527 523.078 363.401 524.806C363.174 523.772 363.174 522.701 363.401 521.667C363.607 520.929 364.021 520.332 364.819 520.733C365.02 520.861 365.193 521.03 365.325 521.227C365.458 521.425 365.548 521.648 365.589 521.882C366.482 524.339 368.67 528.3 369.469 530.794L371.967 538.603C373.527 543.489 375.048 548.636 376.166 553.737C377.209 558.454 381.013 570.084 381.013 570.084",
    fill: "#A04B4B",
    style: {
      fill: "#A04B4B",
      fill: "color(display-p3 0.6275 0.2941 0.2941)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.169 517.687C353.62 520.489 354.653 524.048 355.217 527.224C356.025 531.764 356.391 535.977 357.095 539.985",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71 518.145C358.255 520.536 359.194 523.861 359.814 526.552C360.866 531.101 361.636 535.193 362.548 539.191",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.349 524.684C364.682 529.037 366.618 534.025 368.149 539.546",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.563 546.627C348.215 548.925 348.046 551.372 346.506 553.381",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.286 709.755C526.483 704.954 524.529 699.909 521.833 695.51C519.172 690.978 515.47 687.136 511.03 684.3C508.963 683.101 506.816 682.043 504.605 681.133L486.908 673.361L457.958 662.151L452.594 657.191C449.138 653.996 445.693 650.78 442.262 647.541L441.867 647.168C415.66 622.291 396.168 594.5 379.148 562.076L348.572 575.406C348.572 575.406 361.798 620.245 374.366 639.255C390.965 664.384 410.165 687.242 418.835 694.482C420.381 699.657 422.16 704.751 424.17 709.765L528.286 709.755Z",
    fill: "#4C9CFB",
    style: {
      fill: "#4C9CFB",
      fill: "color(display-p3 0.2980 0.6118 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.485 590.812L386.287 575.128",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.13 572.54L366.186 596.398",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.524 577.557C365.524 577.984 365.397 578.401 365.159 578.756C364.92 579.111 364.581 579.388 364.185 579.551C363.788 579.714 363.352 579.757 362.931 579.674C362.51 579.59 362.124 579.385 361.82 579.083C361.517 578.781 361.31 578.397 361.226 577.978C361.143 577.56 361.186 577.126 361.35 576.732C361.514 576.337 361.792 576 362.149 575.763C362.506 575.526 362.925 575.399 363.354 575.399C363.929 575.402 364.48 575.63 364.886 576.034C365.292 576.438 365.522 576.986 365.524 577.557Z",
    stroke: "#D8A798",
    style: {
      stroke: "#D8A798",
      stroke: "color(display-p3 0.8471 0.6549 0.5961)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.714 709.103L488.232 703.246C489.824 701.11 491.526 699.059 493.333 697.099C498.677 691.362 505.878 687.676 513.679 686.684",
    stroke: "#3589E5",
    style: {
      stroke: "#3589E5",
      stroke: "color(display-p3 0.2078 0.5373 0.8980)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.927 691.672C417.991 683.826 420.476 676.19 425.047 669.794C430.73 661.789 439.081 656.044 449.178 655.782",
    stroke: "#3589E5",
    style: {
      stroke: "#3589E5",
      stroke: "color(display-p3 0.2078 0.5373 0.8980)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.694 694.157C417.247 689.869 416.421 685.068 414.129 681.135",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.74 658.957L446.861 682.871C446.861 682.871 454.94 691.063 466.061 685.729C477.183 680.396 485.29 670.251 485.29 670.251L481.654 655.426",
    fill: "#A04B4B",
    style: {
      fill: "#A04B4B",
      fill: "color(display-p3 0.6275 0.2941 0.2941)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.92 629.149C491.804 625.635 489.698 622.513 486.852 620.153C480.032 614.604 472.536 614.754 465.247 619.032C458.888 622.769 450.152 628.617 445.296 634.231C440.289 640.032 436.936 647.234 442.055 654.016C450.284 664.917 473.372 661.218 484.382 652.278C488.872 648.635 493.099 642.722 493.775 636.902C494.037 634.287 493.746 631.646 492.92 629.149Z",
    fill: "#A04B4B",
    style: {
      fill: "#A04B4B",
      fill: "color(display-p3 0.6275 0.2941 0.2941)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.801 622.077C460.129 623.945 456.118 624.431 452.097 624.88C450.162 625.113 447.607 625.758 447.955 628.28C448.18 629.905 449.608 631.307 450.773 632.297",
    fill: "#A04B4B",
    style: {
      fill: "#A04B4B",
      fill: "color(display-p3 0.6275 0.2941 0.2941)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.797 646.916L448.802 644.674C449.441 643.226 447.356 642.255 446.36 641.759C445.646 641.404 445.261 641.077 444.538 641.554C444.359 641.675 443.307 642.675 443.082 642.488L441.147 640.246C439.573 643.105 438.798 646.33 438.902 649.588C439.066 652.238 440.172 654.744 442.02 656.659C442.877 657.534 443.821 658.32 444.838 659.004C452.419 663.544 461.869 663.198 470.116 660.013C472.705 659.116 475.056 657.647 476.992 655.716C451.78 655.379 447.797 646.916 447.797 646.916Z",
    fill: "#1E1611",
    style: {
      fill: "#1E1611",
      fill: "color(display-p3 0.1176 0.0863 0.0667)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.891 645.235L477.553 645.17C475.872 644.899 474.209 645.17 472.547 644.6C471.188 644.189 470.015 643.321 469.231 642.143C468.357 640.723 469.55 639.901 470.706 639.275C472.442 638.375 474.047 637.243 475.477 635.912C476.652 634.853 477.507 633.491 477.948 631.977C478.389 630.462 478.399 628.856 477.976 627.337C476.896 623.946 473.542 621.947 470.931 619.798C468.32 617.65 465.21 614.502 466.234 610.905C467.258 607.309 470.799 605.992 474.256 606.496C476.135 606.767 478.014 607.29 479.836 607C480.775 606.851 481.715 606.505 482.607 606.3C484.033 605.945 485.531 606.006 486.924 606.475C488.316 606.943 489.543 607.8 490.46 608.944C491.69 610.644 492.169 613.063 494.057 613.997C495.015 614.331 496.008 614.557 497.016 614.67C498.019 614.927 498.948 615.41 499.731 616.083C500.515 616.755 501.132 617.598 501.535 618.547C502.328 620.467 502.348 622.618 501.591 624.553C500.266 628 498.294 629.728 499.919 633.53C503.676 642.367 505.264 653.213 496.274 659.565C493.907 661.228 490.939 662.096 488.976 664.236C487.745 665.553 486.74 667.44 484.946 667.627C484.337 667.634 483.735 667.503 483.185 667.244C482.634 666.985 482.151 666.605 481.771 666.132C481.06 665.314 480.43 664.428 479.892 663.488C479.001 662.27 478.395 660.869 478.117 659.387C477.882 657.258 479 655.24 479.996 653.353C480.991 651.466 482.87 647.869 480.597 646.393C479.771 645.851 478.855 645.459 477.891 645.235Z",
    fill: "#1E1611",
    style: {
      fill: "#1E1611",
      fill: "color(display-p3 0.1176 0.0863 0.0667)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.339 625.964C471.775 624.254 470.742 622.554 469.145 623.33C468.952 623.439 468.788 623.593 468.668 623.778C468.547 623.963 468.472 624.175 468.45 624.395C468.414 624.833 468.449 625.275 468.554 625.702C468.801 627.756 469.438 629.743 470.432 631.559C470.623 631.944 470.92 632.268 471.287 632.494C473.804 633.661 472.658 626.898 472.339 625.964Z",
    fill: "#1E1611",
    style: {
      fill: "#1E1611",
      fill: "color(display-p3 0.1176 0.0863 0.0667)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.546 637.5L449.483 635.912C449.483 635.912 448.788 641.937 451.793 642.535C454.799 643.133 456.546 637.5 456.546 637.5Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.062 630.43C449.65 631.191 450.436 631.779 451.335 632.13",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.898 624.245C459.542 623.851 462.09 622.973 464.413 621.657",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.252 645.479C478.854 643.527 483.588 645.395 484.565 648.281C486.904 655.269 475.642 661.098 470.701 656.773C469.301 655.549 468.249 653.036 469.48 651.271",
    fill: "#A04B4B",
    style: {
      fill: "#A04B4B",
      fill: "color(display-p3 0.6275 0.2941 0.2941)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.504 652.111L472.538 650.766",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.321 645.412C479.701 644.809 477.934 644.714 476.258 645.141",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.657 651.364C469.253 652.11 469.069 652.955 469.129 653.8C469.189 654.645 469.49 655.456 469.996 656.138C471.762 658.697 476.017 658.707 478.591 657.614",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.936 631.728C463.931 632.456 462.691 632.456 462.165 631.728C461.639 630.999 462.033 629.859 463.048 629.121C464.062 628.383 465.293 628.393 465.809 629.121C466.326 629.85 465.941 630.999 464.936 631.728Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.176 669.477C463.814 672.466 448.268 684.021 448.268 684.021L452.682 704.068C475.377 682.583 497.461 677.772 497.677 677.538L489.176 669.477Z",
    fill: "#4C9CFB",
    style: {
      fill: "#4C9CFB",
      fill: "color(display-p3 0.2980 0.6118 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.505 671.214L437.97 677.342C437.97 677.342 436.327 694.39 439.464 703.498L448.266 684.086L447.505 671.214Z",
    fill: "#FCDDD2",
    style: {
      fill: "#FCDDD2",
      fill: "color(display-p3 0.9882 0.8667 0.8235)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.268 684.022L452.682 704.069C475.377 682.583 497.461 677.773 497.677 677.539",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.505 671.214L437.97 677.342C437.97 677.342 436.327 694.39 439.464 703.498L448.266 684.086",
    fill: "#4C9CFB",
    style: {
      fill: "#4C9CFB",
      fill: "color(display-p3 0.2980 0.6118 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.505 671.214L437.97 677.342C437.97 677.342 436.327 694.39 439.464 703.498L448.266 684.086",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.351 616.996C355.923 626.077 359.714 634.771 364.623 642.844",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.188 632.568C355.796 638.398 357.725 644.136 359.964 649.757",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.87 644.787C510.878 648.982 509.476 653.059 506.887 656.371C504.31 659.654 501.168 662.456 497.606 664.647",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.025 664.506C511.537 662.515 514.489 659.679 516.611 656.258",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.592 484.682H651.794V595.845C651.794 597.398 651.174 598.888 650.069 599.987C648.965 601.085 647.467 601.702 645.905 601.702H488.481C486.919 601.702 485.421 601.085 484.317 599.987C483.212 598.888 482.592 597.398 482.592 595.845V484.682Z",
    fill: "#FFE393",
    style: {
      fill: "#FFE393",
      fill: "color(display-p3 1.0000 0.8901 0.5760)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.9 469.027C647.462 469.027 648.96 469.644 650.065 470.743C651.169 471.841 651.79 473.331 651.79 474.884V595.893C651.79 597.447 651.169 598.937 650.065 600.035C648.96 601.133 647.462 601.75 645.9 601.75H488.468C486.906 601.75 485.407 601.133 484.303 600.035C483.198 598.937 482.578 597.447 482.578 595.893V474.903C482.578 474.134 482.73 473.372 483.026 472.661C483.322 471.951 483.756 471.305 484.303 470.761C484.85 470.217 485.499 469.786 486.214 469.492C486.928 469.197 487.694 469.046 488.468 469.046H645.9M645.9 467.645H488.468C486.533 467.647 484.678 468.413 483.309 469.773C481.941 471.134 481.171 472.979 481.169 474.903V595.893C481.171 597.818 481.941 599.662 483.309 601.023C484.678 602.384 486.533 603.149 488.468 603.152H645.9C647.835 603.149 649.69 602.384 651.058 601.023C652.427 599.662 653.196 597.818 653.199 595.893V474.903C653.196 472.979 652.427 471.134 651.058 469.773C649.69 468.413 647.835 467.647 645.9 467.645Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.998 542.068C474.184 542.32 457.52 538.789 441.438 533.913C425.357 529.036 396.05 518.331 396.05 518.331L387.689 543.45C387.689 543.45 431.002 570.737 488.64 575.398",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.002 548.896C515.795 539.443 491.523 540.115 484.562 540.386C477.602 540.657 465.203 538.611 465.203 538.611L460.656 576.454C460.656 576.454 486.422 580.751 500.766 581.797",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.412 557.977C497.169 562.91 496.351 570.121 496.351 575.399C496.351 580.07 498.023 582.667 498.719 587.282C499.545 592.802 502.692 596.744 506.017 601.751H577.407L573.649 562.396L563.984 548.43L543.469 542.984L497.15 555.128",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.833 548.431C517.001 550.975 516.729 553.667 517.034 556.324C517.542 559.351 519.477 561.266 522.238 562.396",
    stroke: "#6D574E",
    style: {
      stroke: "#6D574E",
      stroke: "color(display-p3 0.4275 0.3412 0.3059)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.751 563.226C538.404 565.477 551.714 556.491 552.992 545.038",
    stroke: "#6D574E",
    style: {
      stroke: "#6D574E",
      stroke: "color(display-p3 0.4275 0.3412 0.3059)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.917 597.209C619.747 594.288 618.075 591.592 615.976 589.241C610.524 582.545 604.437 576.385 597.8 570.848L573.912 592.464L588.698 606.719L571.433 637.835L594.324 644.374C594.324 644.374 611.852 625.122 618.559 614.398C621.809 609.073 622.965 603.122 620.917 597.209Z",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.959 630.849C575.959 630.849 565.945 645.178 564.921 647.766C564.062 650.266 563.473 652.849 563.165 655.473C562.225 662.301 565.861 669.317 568.632 672.633C568.95 673.003 569.389 673.251 569.872 673.334C570.896 673.52 571.309 672.988 571.29 671.783L572.972 674.062C573.176 674.387 573.452 674.662 573.779 674.866C574.126 674.966 574.495 674.953 574.833 674.829C575.172 674.704 575.461 674.475 575.658 674.174C576.106 673.5 576.424 672.75 576.597 671.96C577.189 672.82 578.119 673.717 579.011 673.193C579.514 672.764 579.907 672.223 580.16 671.615C580.413 671.006 580.518 670.347 580.467 669.69C580.759 670.625 582.036 670.671 582.731 669.971C583.375 669.163 583.778 668.192 583.896 667.168C584.268 664.576 585.038 662.055 586.179 659.695C587.093 658.266 588.094 656.893 589.175 655.585C592.435 651.12 594.05 645.421 595.102 639.816",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.527 652.942L581.175 655.922C580.808 656.726 580.442 657.529 580.151 658.37C578.837 662.146 579.049 666.283 580.743 669.906",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.991 652.568C574.052 657.08 573.704 662.508 574.352 665.899C574.824 668.096 575.696 670.189 576.926 672.073",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.384 650.868C568.384 650.868 567.801 654.203 567.661 656.081C567.219 662.059 568.017 667.842 571.296 672.269",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.01 543.881L388.599 543.358C386.982 543.256 385.379 542.987 383.818 542.554C382.797 542.201 381.802 541.776 380.84 541.284C376.839 539.341 374.791 538.762 370.958 536.52C368.771 535.209 366.502 534.036 364.167 533.007C361.875 532.027 359.47 531.494 357.366 530.158C357.174 530.054 357.015 529.899 356.906 529.71C356.861 529.548 356.861 529.377 356.906 529.215C357.394 525.777 364.421 526.562 367.239 527.346C368.042 527.656 368.908 527.771 369.765 527.683C369.748 526.582 369.422 525.509 368.826 524.581C367.248 521.779 364.937 519.518 362.852 517.108C360.917 514.838 358.963 512.578 357.216 510.186C355.553 507.954 353.834 503.087 355.14 502.489C356.446 501.891 355.751 503.077 356.173 503.133C355.328 502.62 355.647 500.555 356.258 499.742C356.868 498.93 358.54 500.163 359.076 500.948C358.475 500.191 358.681 498.481 359.301 498.145C360.241 497.697 361.274 498.304 362.119 498.808C362.906 499.394 363.795 499.831 364.74 500.097C364.494 499.48 364.348 498.827 364.308 498.164C364.778 497.585 365.698 497.884 366.346 498.229C379.412 505.31 390.562 516.034 404.455 522.349",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.089 502.356C357.817 504.496 360.137 505.981 362.157 507.821C365.379 510.754 368.441 513.837 371.55 516.882",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.979 500.685C359.974 501.621 361.032 502.488 362.145 503.281C363.329 504.132 364.578 504.888 365.808 505.682C369.317 507.955 372.66 510.471 375.812 513.211",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.109 500.34C366.271 501.329 367.568 502.149 368.961 502.778C373.187 505.015 377.129 507.746 380.702 510.914",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.535 544.693C394.535 544.693 387.142 543.703 384.127 542.909",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.958 546.869C563.04 547.355 568.131 547.803 572.987 549.672C579.102 551.97 584.419 556.285 589.426 560.695C594.658 565.309 599.993 571.577 605.084 576.388L579.009 599.06L560.504 581.124",
    fill: "#32A16E",
    style: {
      fill: "#32A16E",
      fill: "color(display-p3 0.1956 0.6298 0.4302)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.656 606.701C590.92 603.846 593.529 601.279 596.425 599.06",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.389 591.699L598.592 569.803",
    stroke: "#6D574E",
    style: {
      stroke: "#6D574E",
      stroke: "color(display-p3 0.4275 0.3412 0.3059)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.615 578.032L474.56 539.854",
    stroke: "#6D574E",
    style: {
      stroke: "#6D574E",
      stroke: "color(display-p3 0.4275 0.3412 0.3059)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.412 570.848C495.412 570.848 497.216 578.993 497.704 582.487",
    stroke: "#6D574E",
    style: {
      stroke: "#6D574E",
      stroke: "color(display-p3 0.4275 0.3412 0.3059)",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.56 519.779L542.772 524.684L542.058 532.745L548.182 544.525C548.182 544.525 545.195 555.632 531.772 558.397C520.444 560.732 520.697 553.455 520.697 553.455L515.306 537.967",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.889 526.011C506.683 519.967 507.651 516.259 509.952 511.868C511.887 508.132 515.288 502.779 519.186 501.032C524.202 498.79 529.941 501.546 535.004 503.368C543.317 506.394 545.196 516.119 544.257 523.891C543.515 529.86 540.011 532.803 535.746 537.23C530.167 543.022 516.443 547.954 509.351 544.349C504.053 541.649 502.982 532.392 504.889 526.011Z",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.721 562.517C594.989 561.443 596.596 557.622 596.417 554.904C596.126 550.532 594.069 548.272 593.731 545.563C593.515 543.806 594.041 542.022 593.89 540.257C593.693 538.8 593.13 537.416 592.253 536.233C591.376 535.049 590.215 534.104 588.874 533.484C586.18 532.266 583.197 531.816 580.261 532.186C578.006 532.391 575.752 532.868 573.516 532.55C571.654 532.221 569.874 531.536 568.275 530.532C565.355 528.901 562.841 526.637 560.92 523.909C557.773 519.238 557.097 513.325 554.673 508.225C553.441 505.654 551.762 503.32 549.713 501.331C544.773 496.492 540.066 494.698 533.068 494.465C528.268 494.306 521.59 494.941 517.917 499.397C517.917 499.397 510.825 499.575 507.434 503.134C503.414 507.347 503.677 513.409 507.218 518.323C509.031 515.362 510.571 512.232 513.23 509.962C513.093 510.212 513.042 510.5 513.084 510.781C513.126 511.063 513.26 511.323 513.464 511.522C513.883 511.915 514.43 512.144 515.005 512.167C516.538 512.138 518.029 511.668 519.298 510.812C518.848 512.005 518.656 513.278 518.734 514.549C518.728 514.82 518.81 515.085 518.969 515.306C519.197 515.518 519.501 515.633 519.814 515.623C520.866 515.7 521.919 515.508 522.875 515.064C523.83 514.621 524.655 513.942 525.272 513.092C524.699 514.642 524.192 516.585 525.347 517.762C525.791 518.144 526.337 518.39 526.918 518.472C527.5 518.553 528.092 518.465 528.625 518.22C529.696 517.713 530.654 516.998 531.443 516.118C531.039 516.511 531.565 518.743 531.669 519.257C531.893 520.382 532.207 521.488 532.608 522.564C533.764 525.895 535.289 529.087 537.155 532.083C539.118 535.156 541.917 537.492 543.918 540.49C545.186 542.358 546.257 544.46 547.966 545.983C550.174 547.9 552.839 549.221 555.706 549.822C558.524 550.383 561.342 550.131 564.16 550.037C574.54 549.701 582.412 554.867 591.758 562.471",
    fill: "#893D33",
    style: {
      fill: "#893D33",
      fill: "color(display-p3 0.5373 0.2392 0.2000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.501 527.047C532.347 524.544 536.376 523.638 538.368 525.132C543.158 528.738 538.321 537.781 533.014 537.146C531.52 536.959 529.66 535.772 529.66 534.025",
    fill: "#E27769",
    style: {
      fill: "#E27769",
      fill: "color(display-p3 0.8863 0.4667 0.4118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.422 529.54L531.467 532.268",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.861 524.684C533.498 525.023 532.272 525.77 531.348 526.823",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.957 534.014C537.623 535.883 535.519 537.583 533.152 537.256C532.304 537.169 531.511 536.798 530.904 536.204C530.296 535.609 529.91 534.828 529.808 533.986",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.015 545.899C522.054 545.5 525.929 544.103 529.287 541.835",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.148 522.946C511.375 524.537 510.282 525.952 508.935 527.103C508.593 527.332 508.278 527.598 507.996 527.897C507.796 528.126 507.652 528.398 507.574 528.691C507.496 528.984 507.486 529.291 507.545 529.588C507.607 529.885 507.735 530.165 507.921 530.406C508.106 530.647 508.344 530.843 508.616 530.98",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.64 534.556C510.085 534.94 510.632 535.187 511.215 535.268C511.799 535.35 512.393 535.261 512.927 535.014C514.261 534.304 514.289 532.604 514.336 531.277",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.66 519.669C519.637 519.449 520.651 519.449 521.628 519.669C522.614 519.878 523.501 520.411 524.146 521.182C524.843 522.238 525.271 523.446 525.395 524.704",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.801 515.977C508.275 515.659 508.826 515.472 509.397 515.434C509.968 515.396 510.538 515.509 511.051 515.762C511.561 516.023 512.011 516.386 512.373 516.828C512.735 517.27 513.001 517.782 513.155 518.331",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.304 525.244C519.919 526.038 519.148 526.459 518.575 526.178C518.28 525.961 518.079 525.64 518.015 525.28C517.95 524.921 518.026 524.55 518.228 524.245C518.604 523.451 519.383 523.03 519.956 523.311C520.254 523.526 520.456 523.848 520.52 524.208C520.585 524.568 520.508 524.939 520.304 525.244Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.753 521.797C509.368 522.591 508.597 523.012 508.015 522.732C507.72 522.516 507.52 522.196 507.455 521.838C507.39 521.48 507.466 521.111 507.667 520.807C508.053 520.013 508.832 519.593 509.405 519.873C509.696 520.091 509.894 520.411 509.958 520.767C510.023 521.124 509.949 521.492 509.753 521.797Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.183 630.129C624.939 624.302 628.947 616.994 630.755 609.026",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.296 626.898C634.031 623.493 635.129 619.802 635.537 616.006",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.934146,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("foreignObject", {
    x: 453.816,
    y: 630.712,
    width: 224.046,
    height: 224.046
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(14.82px)",
      clipPath: "url(#bgblur_0_11499_163943_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_11499_163943)",
    "data-figma-bg-blur-radius": 29.6473
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 565.839,
    cy: 742.736,
    r: 82.3535,
    transform: "rotate(18.5062 565.839 742.736)",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.888 733.911L603.255 732.536C605.518 731.223 606.225 728.167 604.797 725.618C603.373 723.064 600.376 722.017 598.115 723.33L595.749 724.707L600.888 733.911Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.697 704.815L584.888 707.222L582.737 713.651L575.546 711.244L577.697 704.815Z",
    fill: "#CCCCCC",
    style: {
      fill: "#CCCCCC",
      fill: "color(display-p3 0.8000 0.8000 0.8000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.222 697.335L589.776 701.537C591.239 702.027 592.024 703.603 591.532 705.075L590.517 708.108C590.024 709.58 588.448 710.365 586.985 709.876L574.431 705.674C572.967 705.184 572.182 703.608 572.675 702.136L573.69 699.103C574.183 697.631 575.758 696.845 577.222 697.335Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.292 711.997C599.07 718.617 609.727 740.044 603.096 759.854C596.465 779.666 575.056 790.362 555.278 783.742C545.511 780.473 540.127 775.07 528.38 766.126L533.314 763.645C535.532 762.527 534.927 758.935 532.163 759.061C519.599 759.617 514.642 752.873 514.935 741.486C518.704 746.131 526.018 746.247 528.785 744.863C533.07 742.725 533.061 738.589 525.036 738.559C514.746 738.512 506.767 729.895 506.501 715.097C518.295 726.965 524.246 712.656 537.915 721.575C538.361 716.01 535.474 713.159 527.494 710.713C538.65 703.452 548.347 712.39 562.406 710.368C567.915 709.636 573.666 710.114 579.292 711.997Z",
    fill: "#FD6B65",
    style: {
      fill: "#FD6B65",
      fill: "color(display-p3 0.9922 0.4196 0.3961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.965 756.461C588.21 770.668 572.862 778.336 558.676 773.588C551.865 771.308 546.239 766.415 543.039 759.975C539.838 753.541 539.323 746.093 541.606 739.271C543.891 732.445 548.783 726.815 555.216 723.596C561.646 720.386 569.085 719.861 575.896 722.141C590.082 726.89 597.72 742.257 592.965 756.461Z",
    fill: "#F2F2F2",
    style: {
      fill: "#F2F2F2",
      fill: "color(display-p3 0.9490 0.9490 0.9490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.299 725.634C573.554 725.398 572.753 725.814 572.512 726.559L571.862 728.502C571.261 730.296 573.959 731.199 574.56 729.405L575.21 727.462C575.478 726.704 575.066 725.877 574.299 725.634Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.067 765.168C560.323 764.927 559.523 765.341 559.28 766.093L558.632 768.03C558.029 769.83 560.727 770.733 561.33 768.933L561.978 766.996C562.245 766.239 561.834 765.41 561.067 765.168Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.138 752.679C584.343 752.078 583.44 754.777 585.234 755.378L587.17 756.026C588.963 756.626 589.867 753.927 588.074 753.327L586.138 752.679Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.663 739.466C544.87 738.866 543.967 741.565 545.76 742.165L547.702 742.815C549.497 743.416 550.4 740.717 548.606 740.116L546.663 739.466Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.181 764.112C574.968 763.706 573.881 764.979 574.468 766.111L575.373 767.938C575.705 768.674 576.583 768.98 577.304 768.624C578.023 768.263 578.298 767.38 577.91 766.674L577.006 764.848C576.84 764.499 576.546 764.235 576.181 764.112Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.624 726.819C556.415 726.414 555.331 727.688 555.912 728.82L556.826 730.641C557.156 731.373 558.033 731.691 558.755 731.33C559.474 730.972 559.749 730.081 559.364 729.374L558.457 727.556C558.29 727.207 557.99 726.941 557.624 726.819Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.893 736.615C586.541 736.506 586.151 736.541 585.824 736.716L584.006 737.621C583.272 737.954 582.956 738.832 583.314 739.55C583.672 740.272 584.565 740.547 585.27 740.162L587.089 739.255C588.26 738.694 588.134 736.986 586.893 736.615Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.632 755.227C549.277 755.124 548.891 755.151 548.563 755.328L546.735 756.239C546.001 756.571 545.695 757.443 546.052 758.164C546.412 758.883 547.298 759.167 548.006 758.779L549.828 757.865C550.999 757.306 550.872 755.606 549.632 755.227Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.96 745.85C569.087 746.227 569.681 747.411 569.303 748.543C568.923 749.678 567.738 750.263 566.61 749.885C565.484 749.508 564.888 748.327 565.267 747.192C565.647 746.059 566.835 745.473 567.96 745.85ZM580.028 740.028C579.682 739.919 579.298 739.948 578.97 740.116L570.675 744.264C570.168 743.78 569.563 743.389 568.862 743.155C566.28 742.29 563.448 743.712 562.584 746.294C561.719 748.877 563.123 751.72 565.706 752.584C568.289 753.449 571.123 752.025 571.987 749.442C572.292 748.532 572.303 747.599 572.094 746.726L580.236 742.655C581.387 742.087 581.258 740.408 580.028 740.028Z",
    fill: "#737373",
    style: {
      fill: "#737373",
      fill: "color(display-p3 0.4490 0.4490 0.4490)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("foreignObject", {
    x: 33.8391,
    y: 226.315,
    width: 177.283,
    height: 177.284
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(11.73px)",
      clipPath: "url(#bgblur_1_11499_163943_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_11499_163943)",
    "data-figma-bg-blur-radius": 23.4598
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122.481,
    cy: 314.957,
    r: 65.166,
    transform: "rotate(-14.4831 122.481 314.957)",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11499_163943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1701 313.952L94.5673 282.893C94.6066 282.816 94.6746 282.757 94.7567 282.73C94.8388 282.702 94.9283 282.708 95.006 282.746L134.792 302.468C134.87 302.508 134.928 302.577 134.956 302.66C134.983 302.742 134.977 302.833 134.94 302.911L119.543 333.97C119.503 334.048 119.434 334.107 119.352 334.134C119.269 334.162 119.179 334.156 119.1 334.119L79.3182 314.395C79.2791 314.376 79.2442 314.35 79.2156 314.317C79.1869 314.284 79.1651 314.246 79.1513 314.205C79.1376 314.163 79.1323 314.12 79.1356 314.077C79.1389 314.033 79.1509 313.991 79.1707 313.952L79.1701 313.952Z",
    fill: "#006694",
    style: {
      fill: "#006694",
      fill: "color(display-p3 0.0000 0.4000 0.5804)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6523 298.237L104.174 287.289L134.793 302.468C134.87 302.508 134.929 302.577 134.956 302.66C134.984 302.742 134.978 302.832 134.94 302.911L119.544 333.97C119.503 334.048 119.435 334.107 119.352 334.134C119.269 334.162 119.179 334.156 119.1 334.118L117.195 333.171L90.4513 300.142C90.226 299.862 90.1205 299.505 90.1581 299.148C90.1957 298.791 90.3732 298.463 90.6518 298.237L90.6523 298.237Z",
    fill: "#005C85",
    style: {
      fill: "#005C85",
      fill: "color(display-p3 0.0000 0.3608 0.5216)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2957 299.032L118.24 277.22C118.308 277.166 118.395 277.14 118.481 277.15C118.567 277.159 118.646 277.202 118.701 277.269L146.641 311.781C146.669 311.814 146.69 311.852 146.703 311.894C146.716 311.935 146.72 311.979 146.716 312.022C146.712 312.065 146.699 312.107 146.679 312.145C146.659 312.183 146.631 312.217 146.597 312.245L119.652 334.057C119.584 334.111 119.497 334.136 119.41 334.127C119.323 334.117 119.243 334.075 119.187 334.008L91.2475 299.498C91.1929 299.43 91.1674 299.342 91.1764 299.256C91.1855 299.169 91.2284 299.089 91.2959 299.033L91.2957 299.032Z",
    fill: "#60B7FF",
    style: {
      fill: "#60B7FF",
      fill: "color(display-p3 0.3765 0.7176 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.186 289.559L125.111 285.188L146.64 311.782C146.668 311.816 146.689 311.854 146.702 311.895C146.715 311.937 146.72 311.98 146.715 312.023C146.711 312.066 146.699 312.108 146.678 312.147C146.658 312.185 146.63 312.219 146.597 312.246L119.652 334.058C119.583 334.112 119.496 334.137 119.409 334.128C119.323 334.119 119.243 334.077 119.187 334.01L117.842 332.346L107.217 291.21C107.172 291.038 107.162 290.859 107.186 290.683C107.211 290.507 107.27 290.337 107.36 290.184C107.45 290.031 107.569 289.897 107.711 289.79C107.853 289.682 108.014 289.604 108.186 289.559Z",
    fill: "#56A5E6",
    style: {
      fill: "#56A5E6",
      fill: "color(display-p3 0.3373 0.6471 0.9020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.443 290.552L133.439 284.096L144.623 290.688L153.515 325.11C153.536 325.195 153.523 325.285 153.479 325.361C153.434 325.436 153.362 325.491 153.277 325.513L119.713 334.183C119.671 334.194 119.627 334.196 119.585 334.19C119.542 334.183 119.501 334.169 119.464 334.146C119.427 334.124 119.395 334.095 119.369 334.06C119.343 334.026 119.325 333.986 119.314 333.944L108.21 290.954C108.199 290.912 108.196 290.869 108.201 290.826C108.207 290.783 108.221 290.742 108.243 290.705C108.264 290.667 108.293 290.635 108.328 290.609C108.362 290.582 108.401 290.563 108.443 290.552Z",
    fill: "#EAF6FF",
    style: {
      fill: "#EAF6FF",
      fill: "color(display-p3 0.9176 0.9647 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.44 284.095L135.221 290.988C135.359 291.517 135.7 291.969 136.17 292.246C136.64 292.523 137.201 292.603 137.73 292.467L144.624 290.687L133.44 284.095Z",
    fill: "#BEC7CF",
    style: {
      fill: "#BEC7CF",
      fill: "color(display-p3 0.7451 0.7804 0.8118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.961 318.876L150.189 312.101C151.52 311.762 152.93 311.963 154.113 312.66C155.296 313.357 156.155 314.494 156.502 315.822L161.825 336.428C162.165 337.759 161.965 339.17 161.267 340.353C160.57 341.536 159.433 342.395 158.104 342.742L111.604 354.753C110.273 355.092 108.862 354.891 107.679 354.194C106.497 353.497 105.638 352.36 105.29 351.032L97.3756 320.391C97.0963 319.298 97.2615 318.138 97.835 317.167C98.4085 316.195 99.3435 315.49 100.436 315.206L109.193 312.944C110.646 312.569 111.865 313.207 113.164 313.95L119.99 317.87C121.29 318.617 122.508 319.251 123.961 318.876Z",
    fill: "#FFB000",
    style: {
      fill: "#FFB000",
      fill: "color(display-p3 1.0000 0.6902 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.856 297.989C115.562 298.061 115.251 298.015 114.991 297.859C114.731 297.704 114.543 297.452 114.467 297.159C114.391 296.866 114.434 296.554 114.586 296.292C114.739 296.031 114.988 295.839 115.28 295.76L130.017 291.954C130.311 291.881 130.622 291.928 130.882 292.083C131.142 292.239 131.33 292.49 131.406 292.784C131.482 293.077 131.439 293.388 131.286 293.65C131.134 293.912 130.885 294.103 130.592 294.183L115.856 297.989ZM120.056 314.249C119.761 314.326 119.447 314.282 119.184 314.127C118.921 313.972 118.73 313.718 118.654 313.423C118.578 313.127 118.622 312.814 118.777 312.551C118.932 312.288 119.185 312.097 119.481 312.021L142.753 306.009C143.049 305.933 143.363 305.977 143.626 306.132C143.889 306.287 144.079 306.54 144.156 306.836C144.232 307.131 144.188 307.445 144.033 307.708C143.878 307.971 143.625 308.162 143.329 308.238L120.056 314.249ZM118.657 308.831C118.362 308.903 118.052 308.856 117.791 308.701C117.531 308.546 117.343 308.294 117.267 308.001C117.192 307.707 117.234 307.396 117.387 307.134C117.539 306.872 117.788 306.681 118.081 306.602L141.354 300.59C141.501 300.55 141.654 300.54 141.805 300.56C141.956 300.58 142.102 300.63 142.233 300.706C142.365 300.783 142.48 300.885 142.572 301.006C142.664 301.128 142.731 301.266 142.769 301.413C142.807 301.561 142.816 301.714 142.794 301.865C142.772 302.016 142.721 302.161 142.643 302.292C142.565 302.422 142.461 302.536 142.339 302.627C142.216 302.718 142.077 302.783 141.929 302.819L118.657 308.831ZM117.257 303.412C117.111 303.449 116.958 303.458 116.809 303.437C116.659 303.416 116.515 303.366 116.385 303.289C116.254 303.212 116.141 303.11 116.05 302.99C115.959 302.869 115.892 302.731 115.855 302.585C115.817 302.439 115.808 302.286 115.829 302.137C115.85 301.987 115.901 301.843 115.977 301.713C116.054 301.583 116.156 301.469 116.277 301.378C116.397 301.287 116.535 301.221 116.681 301.183L139.954 295.171C140.1 295.134 140.253 295.125 140.402 295.146C140.552 295.167 140.696 295.218 140.826 295.294C140.956 295.371 141.07 295.473 141.161 295.593C141.252 295.714 141.318 295.852 141.356 295.998C141.394 296.144 141.403 296.297 141.381 296.446C141.36 296.596 141.31 296.74 141.233 296.87C141.156 297.001 141.055 297.114 140.934 297.205C140.813 297.296 140.676 297.362 140.53 297.4L117.257 303.412Z",
    fill: "#BEC7CF",
    style: {
      fill: "#BEC7CF",
      fill: "color(display-p3 0.7451 0.7804 0.8118)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.191 340.766C109.896 340.843 109.582 340.798 109.319 340.643C109.056 340.488 108.865 340.235 108.789 339.94C108.712 339.644 108.757 339.33 108.912 339.067C109.067 338.804 109.32 338.614 109.615 338.537L120.485 335.73C120.78 335.653 121.094 335.698 121.357 335.853C121.62 336.008 121.811 336.261 121.887 336.556C121.963 336.852 121.919 337.166 121.764 337.429C121.609 337.692 121.356 337.882 121.06 337.959L110.191 340.766ZM112.157 348.378C111.862 348.454 111.548 348.41 111.285 348.255C111.022 348.1 110.831 347.847 110.755 347.551C110.679 347.256 110.723 346.942 110.878 346.679C111.033 346.416 111.286 346.225 111.582 346.149L153.958 335.203C154.253 335.127 154.567 335.171 154.83 335.326C155.093 335.481 155.284 335.734 155.36 336.03C155.436 336.325 155.392 336.639 155.237 336.902C155.082 337.165 154.829 337.356 154.533 337.432L112.157 348.378Z",
    fill: "#D99E1F",
    style: {
      fill: "#D99E1F",
      fill: "color(display-p3 0.8490 0.6211 0.1233)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.375 312.954C151.181 313.234 151.906 313.708 152.485 314.335C153.065 314.962 153.48 315.722 153.695 316.548L159.018 337.154C159.358 338.485 159.158 339.896 158.46 341.079C157.763 342.262 156.625 343.121 155.297 343.468L158.103 342.743C159.432 342.396 160.569 341.537 161.267 340.354C161.964 339.171 162.164 337.76 161.824 336.43L156.502 315.823C156.333 315.165 156.034 314.547 155.623 314.005C155.005 313.188 154.159 312.572 153.193 312.234C152.226 311.895 151.181 311.849 150.188 312.102L147.382 312.827C148.37 312.572 149.412 312.616 150.375 312.954ZM119.99 317.871L114.322 314.619L113.163 313.951C111.864 313.208 110.645 312.57 109.192 312.945L106.391 313.669C107.839 313.295 109.058 313.933 110.357 314.676L115.03 317.357L117.188 318.595C118.483 319.343 119.701 319.977 121.154 319.602L123.96 318.877C122.507 319.252 121.29 318.619 119.99 317.871Z",
    fill: "#C9982D",
    style: {
      fill: "#C9982D",
      fill: "color(display-p3 0.7875 0.5977 0.1749)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.553 326.26C158.431 325.775 160.124 324.743 161.416 323.296C162.708 321.849 163.542 320.051 163.813 318.13C164.083 316.209 163.778 314.251 162.936 312.503C162.094 310.755 160.752 309.297 159.081 308.312C157.409 307.326 155.483 306.859 153.546 306.968C151.609 307.078 149.748 307.759 148.198 308.926C146.648 310.093 145.48 311.694 144.839 313.525C144.199 315.357 144.117 317.337 144.602 319.215C145.257 321.732 146.882 323.886 149.122 325.206C151.362 326.527 154.034 326.905 156.553 326.26Z",
    fill: "#25C784",
    style: {
      fill: "#25C784",
      fill: "color(display-p3 0.1451 0.7804 0.5157)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.755 319.519C148.622 319.444 148.506 319.342 148.413 319.222C148.319 319.101 148.251 318.963 148.211 318.815C148.172 318.668 148.162 318.514 148.183 318.363C148.203 318.211 148.254 318.066 148.331 317.934C148.408 317.802 148.511 317.687 148.633 317.596C148.756 317.504 148.895 317.438 149.043 317.401C149.191 317.363 149.345 317.356 149.496 317.379C149.647 317.402 149.792 317.454 149.922 317.533L152.613 319.12L157.107 311.496C157.262 311.233 157.515 311.042 157.81 310.966C158.105 310.89 158.419 310.934 158.682 311.089C158.945 311.244 159.135 311.496 159.211 311.792C159.288 312.087 159.243 312.401 159.089 312.663L154.009 321.281C153.853 321.543 153.601 321.733 153.305 321.809C153.01 321.885 152.697 321.841 152.434 321.687L148.755 319.519Z",
    fill: "#EAF6FF",
    style: {
      fill: "#EAF6FF",
      fill: "color(display-p3 0.9176 0.9647 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.846 307.505C153.228 307.101 155.674 307.589 157.718 308.876C159.762 310.164 161.259 312.16 161.922 314.482C162.586 316.805 162.37 319.29 161.315 321.463C160.26 323.636 158.441 325.343 156.205 326.258C156.053 326.322 155.895 326.382 155.736 326.437C155.902 326.409 156.063 326.377 156.226 326.34C156.336 326.316 156.444 326.288 156.552 326.26C157.391 326.045 158.197 325.719 158.949 325.29C161.015 324.114 162.585 322.228 163.365 319.982C164.145 317.736 164.083 315.283 163.19 313.079C162.297 310.876 160.635 309.071 158.511 308.002C156.387 306.932 153.948 306.67 151.646 307.265C151.375 307.335 151.107 307.414 150.846 307.505L150.846 307.505Z",
    fill: "#21B365",
    style: {
      fill: "#21B365",
      fill: "color(display-p3 0.1294 0.7020 0.3966)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.594 291.212L147.352 309.634C147.903 309.113 148.512 308.659 149.168 308.28L144.624 290.687L142.594 291.212Z",
    fill: "#D3DDE6",
    style: {
      fill: "#D3DDE6",
      fill: "color(display-p3 0.8275 0.8667 0.9020)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 103.251,
    y: 707.649,
    width: 140.804,
    height: 140.805
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(9.32px)",
      clipPath: "url(#bgblur_3_11499_163943_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_11499_163943)",
    "data-figma-bg-blur-radius": 18.6346
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.653,
    cy: 778.051,
    r: 51.7627,
    transform: "rotate(-6.96315 173.653 778.051)",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11499_163943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.038 797.211L181.443 800.526C181.779 803.277 179.83 805.77 177.078 806.106C174.327 806.442 171.835 804.492 171.499 801.741L171.094 798.426C170.981 797.498 171.621 796.68 172.549 796.566L179.179 795.756C180.107 795.643 180.925 796.283 181.038 797.211Z",
    fill: "#4A6F63",
    style: {
      fill: "#4A6F63",
      fill: "color(display-p3 0.2902 0.4353 0.3893)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 797.212L181.445 800.527C181.781 803.278 179.831 805.77 177.08 806.107L175.865 796.162L179.18 795.757C180.108 795.644 180.926 796.284 181.04 797.212Z",
    fill: "#384942",
    style: {
      fill: "#384942",
      fill: "color(display-p3 0.2196 0.2863 0.2585)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.006 756.384C160.597 757.655 153.799 766.997 155.001 776.842C155.722 782.742 159.215 787.934 164.579 790.811C166.056 791.606 167.091 793.196 167.322 795.085L167.375 795.516C167.711 798.267 170.202 800.217 172.954 799.881L179.584 799.071C182.335 798.735 184.285 796.243 183.949 793.492L183.884 792.961C183.665 791.172 184.416 789.33 185.919 787.868C190.135 783.821 192.172 778.189 191.464 772.389C190.241 762.378 181.187 755.174 171.006 756.384Z",
    fill: "#FFE470",
    style: {
      fill: "#FFE470",
      fill: "color(display-p3 1.0000 0.8941 0.4392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.465 772.388C192.173 778.189 190.136 783.82 185.92 787.867C184.417 789.329 183.666 791.171 183.885 792.961L183.95 793.491C184.286 796.242 182.336 798.734 179.585 799.07L176.27 799.475L171.007 756.383C181.188 755.173 190.242 762.377 191.465 772.388Z",
    fill: "#FFC33F",
    style: {
      fill: "#FFC33F",
      fill: "color(display-p3 1.0000 0.7665 0.2462)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.065 773.02L196.639 773.439C195.724 773.55 194.891 772.899 194.78 771.984C194.668 771.067 195.319 770.236 196.235 770.124L199.66 769.705C200.576 769.594 201.408 770.244 201.52 771.16C201.632 772.076 200.981 772.908 200.065 773.02Z",
    fill: "#F4D7AF",
    style: {
      fill: "#F4D7AF",
      fill: "color(display-p3 0.9569 0.8431 0.6863)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.232 779.107L146.806 779.525C145.891 779.637 145.058 778.986 144.947 778.07C144.835 777.154 145.486 776.323 146.402 776.211L149.827 775.792C150.743 775.68 151.575 776.331 151.687 777.247C151.799 778.163 151.148 778.995 150.232 779.107Z",
    fill: "#FAECD8",
    style: {
      fill: "#FAECD8",
      fill: "color(display-p3 0.9804 0.9255 0.8471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.609 757.519C185.882 756.951 185.754 755.902 186.322 755.175L188.38 752.545C188.948 751.819 189.997 751.691 190.723 752.259C191.45 752.827 191.578 753.876 191.01 754.603L188.952 757.233C188.384 757.959 187.335 758.087 186.609 757.519Z",
    fill: "#F4D7AF",
    style: {
      fill: "#F4D7AF",
      fill: "color(display-p3 0.9569 0.8431 0.6863)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.743 796.972C155.017 796.404 154.889 795.355 155.457 794.628L157.515 791.998C158.083 791.272 159.132 791.144 159.858 791.712C160.585 792.28 160.713 793.329 160.144 794.056L158.087 796.686C157.519 797.412 156.47 797.54 155.743 796.972Z",
    fill: "#FAECD8",
    style: {
      fill: "#FAECD8",
      fill: "color(display-p3 0.9804 0.9255 0.8471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.793 761.527L151.163 759.469C150.437 758.901 150.309 757.852 150.877 757.125C151.445 756.399 152.494 756.271 153.221 756.839L155.85 758.897C156.577 759.465 156.705 760.514 156.137 761.24C155.568 761.967 154.52 762.095 153.793 761.527Z",
    fill: "#FAECD8",
    style: {
      fill: "#FAECD8",
      fill: "color(display-p3 0.9804 0.9255 0.8471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.246 792.392L190.616 790.334C189.89 789.766 189.762 788.717 190.33 787.991C190.898 787.264 191.947 787.136 192.674 787.704L195.304 789.762C196.03 790.33 196.158 791.379 195.59 792.106C195.021 792.832 193.973 792.96 193.246 792.392Z",
    fill: "#F4D7AF",
    style: {
      fill: "#F4D7AF",
      fill: "color(display-p3 0.9569 0.8431 0.6863)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.683 775.412L173.223 770.68L175.256 765.015C175.532 764.241 175.194 763.408 174.471 762.991C173.751 762.608 172.864 762.784 172.374 763.449L163.644 774.608C163.319 774.984 163.214 775.502 163.308 775.995C163.436 776.484 163.753 776.883 164.187 777.132L173.647 781.864L171.614 787.529C171.338 788.303 171.676 789.137 172.399 789.553C173.119 789.936 174.006 789.76 174.496 789.095L183.226 777.936C183.55 777.56 183.656 777.042 183.562 776.549C183.434 776.06 183.117 775.661 182.683 775.412Z",
    fill: "#FDBF00",
    style: {
      fill: "#FDBF00",
      fill: "color(display-p3 0.9922 0.7490 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.562 776.55C183.656 777.043 183.551 777.56 183.227 777.936L174.933 788.537L171.938 764.008L172.374 763.45C172.865 762.784 173.752 762.609 174.471 762.992C175.195 763.408 175.532 764.241 175.257 765.015L173.223 770.68L182.683 775.412C183.117 775.662 183.435 776.06 183.562 776.55Z",
    fill: "#FF9F00",
    style: {
      fill: "#FF9F00",
      fill: "color(display-p3 1.0000 0.6235 0.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 284.315,
    y: 816.72,
    width: 189.442,
    height: 188.914
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(12.1px)",
      clipPath: "url(#bgblur_5_11499_163943_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_11499_163943)",
    "data-figma-bg-blur-radius": 24.201
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.301,
    y: 872.277,
    width: 120.812,
    height: 120,
    rx: 20.4075,
    transform: "rotate(-17.6206 303.301 872.277)",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11499_163943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.712 925.079C393.89 926.287 393.944 927.49 393.879 928.678L398.517 930.797C398.35 932.021 398.099 933.225 397.74 934.395L392.643 934.373C392.196 935.496 391.639 936.571 390.979 937.583L393.938 941.733C393.19 942.702 392.351 943.6 391.449 944.444L387.042 941.879C386.109 942.617 385.096 943.267 384.006 943.819L384.49 948.903C383.924 949.133 383.354 949.361 382.76 949.55C382.167 949.738 381.57 949.881 380.974 950.02L378.435 945.589C377.228 945.766 376.024 945.82 374.836 945.755L372.717 950.393C371.494 950.226 370.29 949.975 369.12 949.616L369.142 944.519C368.019 944.073 366.944 943.515 365.932 942.856L361.781 945.816C360.813 945.067 359.915 944.228 359.071 943.326L361.636 938.919C360.898 937.986 360.248 936.973 359.695 935.883L354.612 936.367C354.381 935.8 354.153 935.23 353.965 934.637C353.776 934.043 353.634 933.446 353.495 932.85L357.926 930.312C357.749 929.104 357.694 927.901 357.759 926.713L353.121 924.593C353.289 923.37 353.539 922.166 353.898 920.996L358.996 921.018C359.442 919.895 359.999 918.82 360.659 917.808L357.7 913.657C358.448 912.689 359.288 911.791 360.19 910.947L364.597 913.512C365.53 912.774 366.543 912.124 367.632 911.571L367.148 906.488C367.715 906.257 368.284 906.029 368.878 905.841C369.471 905.652 370.068 905.51 370.665 905.371L373.203 909.802C374.41 909.625 375.614 909.571 376.802 909.635L378.921 904.997C380.144 905.165 381.348 905.416 382.518 905.775L382.496 910.872C383.619 911.318 384.694 911.876 385.707 912.536L389.857 909.576C390.826 910.325 391.724 911.164 392.568 912.066L390.003 916.473C390.741 917.406 391.391 918.419 391.943 919.509L397.027 919.025C397.257 919.591 397.485 920.161 397.674 920.754C397.862 921.348 398.005 921.944 398.144 922.541L393.712 925.079ZM372.166 916.193C365.813 918.211 362.299 924.996 364.317 931.349C366.335 937.701 373.12 941.215 379.472 939.198C385.825 937.18 389.339 930.395 387.321 924.042C385.304 917.689 378.519 914.175 372.166 916.193Z",
    fill: "#F1F7F3",
    style: {
      fill: "#F1F7F3",
      fill: "color(display-p3 0.9450 0.9683 0.9516)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.397 887.669C399.407 888.32 399.353 888.965 399.235 889.594L402.157 892.498C401.79 893.468 401.313 894.39 400.732 895.249L396.675 894.538C396.23 894.999 395.734 895.414 395.196 895.782L395.209 899.905C394.742 900.117 394.263 900.31 393.764 900.468C393.265 900.627 392.763 900.745 392.261 900.843L389.892 897.467C389.241 897.478 388.595 897.423 387.967 897.305L385.063 900.227C384.093 899.86 383.171 899.383 382.312 898.802L383.023 894.745C382.562 894.3 382.147 893.804 381.779 893.266L377.656 893.279C377.444 892.812 377.251 892.333 377.093 891.834C376.934 891.335 376.815 890.833 376.718 890.331L380.094 887.962C380.083 887.311 380.138 886.666 380.256 886.037L377.334 883.133C377.701 882.163 378.178 881.242 378.759 880.382L382.816 881.093C383.261 880.633 383.757 880.217 384.295 879.85L384.282 875.726C384.749 875.514 385.228 875.322 385.727 875.163C386.226 875.004 386.728 874.886 387.23 874.788L389.599 878.164C390.25 878.153 390.895 878.208 391.524 878.326L394.428 875.404C395.398 875.771 396.319 876.248 397.179 876.829L396.468 880.886C396.928 881.331 397.344 881.827 397.711 882.365L401.835 882.352C402.047 882.819 402.239 883.298 402.398 883.797C402.557 884.296 402.675 884.798 402.773 885.3L399.397 887.669ZM388.284 883.215C385.743 884.022 384.337 886.736 385.144 889.277C385.951 891.818 388.666 893.224 391.207 892.416C393.748 891.609 395.153 888.895 394.346 886.354C393.539 883.813 390.825 882.408 388.284 883.215Z",
    fill: "#FFB000",
    style: {
      fill: "#FFB000",
      fill: "color(display-p3 1.0000 0.6902 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.935 910.675C416.961 911.37 416.904 912.054 416.763 912.72L418.673 914.765C418.364 915.594 417.956 916.381 417.458 917.112L414.686 916.732C414.223 917.231 413.697 917.673 413.114 918.053L413.019 920.854C412.622 921.036 412.215 921.202 411.788 921.337C411.362 921.473 410.934 921.572 410.505 921.652L408.81 919.42C408.116 919.446 407.431 919.388 406.765 919.248L404.72 921.157C403.891 920.848 403.105 920.441 402.374 919.942L402.753 917.17C402.255 916.708 401.812 916.181 401.433 915.6L398.632 915.505C398.45 915.107 398.284 914.7 398.148 914.273C398.013 913.846 397.914 913.418 397.833 912.989L400.065 911.295C400.04 910.6 400.097 909.916 400.238 909.251L398.329 907.206C398.638 906.377 399.045 905.59 399.544 904.86L402.316 905.239C402.778 904.74 403.305 904.298 403.887 903.918L403.982 901.117C404.379 900.934 404.786 900.768 405.212 900.633C405.639 900.497 406.067 900.398 406.496 900.318L408.191 902.55C408.885 902.524 409.569 902.582 410.236 902.722L412.281 900.813C413.11 901.122 413.896 901.529 414.627 902.028L414.247 904.8C414.746 905.262 415.188 905.789 415.568 906.371L418.369 906.467C418.551 906.863 418.717 907.27 418.852 907.697C418.988 908.124 419.087 908.552 419.168 908.981L416.935 910.675ZM407.404 907.534C405.498 908.14 404.444 910.175 405.05 912.081C405.655 913.987 407.69 915.041 409.596 914.436C411.502 913.83 412.556 911.795 411.951 909.889C411.346 907.983 409.31 906.929 407.404 907.534Z",
    fill: "#4C9CFB",
    style: {
      fill: "#4C9CFB",
      fill: "color(display-p3 0.2980 0.6118 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.395 870.841L400.079 871.65L400.888 878.965L403.287 878.701L402.923 875.408C404.775 877.372 406.175 879.741 407 882.337C408.259 886.303 408.135 890.448 406.641 894.323L408.893 895.191C410.563 890.861 410.708 886.037 409.3 881.607C408.343 878.594 406.704 875.845 404.529 873.586L407.661 873.239L407.395 870.841Z",
    fill: "#F1F7F3",
    style: {
      fill: "#F1F7F3",
      fill: "color(display-p3 0.9450 0.9683 0.9516)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.296 894.052L366.186 896.195L368.246 897.262C367.601 897.423 366.956 897.588 366.322 897.79C357.424 900.616 350.294 907.2 346.762 915.853L348.996 916.766C352.257 908.777 358.838 902.699 367.052 900.09C367.638 899.904 368.233 899.752 368.829 899.603L367.862 901.47L370.005 902.58L372.914 896.962L367.296 894.052Z",
    fill: "#F1F7F3",
    style: {
      fill: "#F1F7F3",
      fill: "color(display-p3 0.9450 0.9683 0.9516)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 281.845,
    y: 61.6379,
    width: 408.272,
    height: 262.136
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(14.82px)",
      clipPath: "url(#bgblur_7_11499_163943_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_11499_163943)",
    "data-figma-bg-blur-radius": 29.6473
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.266,
    y: 88.416,
    width: 336.605,
    height: 168.647,
    rx: 25,
    transform: "rotate(7.03084 329.266 88.416)",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.106 193.642L586.727 191.768L582.369 188.842L579.101 190.933C577.712 189.793 576.134 188.902 574.438 188.3L574.59 184.454L569.143 181.832L568.511 183.706L567.705 187.466C565.914 187.636 564.167 188.113 562.54 188.875L559.915 186.058L555.72 187.899L555.099 189.774L557.191 193.024C556.08 194.403 555.214 195.96 554.631 197.629L551.362 195.603L550.741 197.477L549.979 203.502L553.759 204.303C553.923 206.085 554.402 207.824 555.175 209.439L552.996 210.176L552.365 212.05L556.112 216.85L559.381 214.759C560.766 215.898 562.34 216.789 564.033 217.392L563.88 221.238L569.938 221.986L570.559 220.111L570.744 218.237C572.534 218.064 574.281 217.588 575.909 216.828L578.534 219.645L583.361 215.918L583.982 214.044L581.258 212.689C582.406 211.313 583.302 209.747 583.905 208.063L587.773 208.215L588.394 206.34L588.536 202.191L584.755 201.389C584.586 199.608 584.107 197.87 583.339 196.253L586.106 193.642ZM575.124 210.414C573.619 211.575 571.802 212.266 569.903 212.401C568.003 212.535 566.106 212.106 564.451 211.168C562.797 210.231 561.459 208.826 560.607 207.132C559.755 205.438 559.427 203.531 559.664 201.652C559.902 199.773 560.694 198.006 561.941 196.575C563.188 195.143 564.834 194.112 566.671 193.611C568.507 193.109 570.452 193.161 572.259 193.758C574.066 194.356 575.655 195.473 576.824 196.968C578.39 198.976 579.09 201.52 578.772 204.041C578.453 206.562 577.141 208.854 575.124 210.414Z",
    fill: "#C3E4D4",
    style: {
      fill: "#C3E4D4",
      fill: "color(display-p3 0.7635 0.8952 0.8306)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.727 191.801L582.958 186.969L579.689 189.06C578.324 187.911 576.768 187.005 575.091 186.384L575.233 182.548L569.186 181.79L568.369 185.55C566.58 185.716 564.833 186.189 563.205 186.947L560.579 184.217L555.72 187.901L557.812 191.151C556.67 192.531 555.774 194.096 555.165 195.778L551.362 195.604L550.6 201.628L554.38 202.43C554.544 204.212 555.024 205.95 555.797 207.566L552.964 210.177L556.701 214.977L559.969 212.886C561.357 214.028 562.935 214.919 564.632 215.519L564.48 219.365L570.526 220.113L571.344 216.364C573.133 216.19 574.88 215.714 576.508 214.955L579.134 217.772L583.949 214.045L581.857 210.795C583.005 209.419 583.901 207.853 584.505 206.168L588.362 206.32L589.124 200.296L585.344 199.494C585.18 197.712 584.7 195.974 583.927 194.358L586.727 191.801ZM575.745 208.574C574.238 209.724 572.423 210.407 570.528 210.534C568.632 210.661 566.741 210.228 565.092 209.289C563.443 208.35 562.111 206.947 561.262 205.257C560.413 203.567 560.086 201.665 560.322 199.79C560.557 197.915 561.345 196.151 562.586 194.721C563.827 193.29 565.466 192.257 567.297 191.75C569.127 191.244 571.067 191.287 572.873 191.875C574.679 192.462 576.269 193.567 577.445 195.052C578.228 196.047 578.806 197.186 579.145 198.404C579.484 199.622 579.577 200.894 579.419 202.148C579.261 203.402 578.855 204.613 578.224 205.71C577.594 206.807 576.751 207.769 575.745 208.541V208.574Z",
    fill: "#DCFDEC",
    style: {
      fill: "#DCFDEC",
      fill: "color(display-p3 0.8627 0.9922 0.9255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.841 155.125L587.309 153.196L584.139 149.653L580.522 151.051C579.396 149.644 578.027 148.448 576.48 147.519L577.417 143.77L571.621 141.809L570.063 145.33C568.266 145.132 566.448 145.249 564.691 145.677L562.687 142.426L557.664 143.185L557.185 145.113L558.59 148.71C557.183 149.833 555.981 151.189 555.039 152.719L551.28 151.712L549.765 155.547L549.297 157.465L552.849 159.025C552.646 160.808 552.76 162.612 553.186 164.356L550.332 164.432L549.863 166.349L552.565 171.821L556.182 170.423C557.309 171.829 558.677 173.025 560.225 173.955L559.288 177.715L565.084 179.687L566.62 176.176C568.417 176.375 570.235 176.257 571.991 175.83L573.996 179.08L579.498 176.393L579.966 174.475L578.092 172.807C579.503 171.684 580.705 170.323 581.644 168.787L585.403 169.719L587.386 163.955L587.854 162.026L583.834 162.395C584.037 160.612 583.923 158.807 583.496 157.064L586.841 155.125ZM572.612 169.383C570.896 170.22 568.969 170.531 567.075 170.279C565.18 170.026 563.404 169.221 561.97 167.964C560.536 166.707 559.509 165.056 559.018 163.219C558.528 161.382 558.596 159.442 559.215 157.643C559.833 155.845 560.974 154.269 562.493 153.116C564.012 151.962 565.841 151.282 567.749 151.162C569.656 151.042 571.556 151.487 573.209 152.442C574.862 153.396 576.194 154.816 577.035 156.522C577.594 157.655 577.923 158.887 578.003 160.147C578.083 161.406 577.913 162.67 577.502 163.864C577.092 165.058 576.448 166.16 575.609 167.107C574.77 168.054 573.752 168.828 572.612 169.383Z",
    fill: "#D17E11",
    style: {
      fill: "#D17E11",
      fill: "color(display-p3 0.8196 0.4941 0.0667)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.313 153.197L584.611 147.779L580.994 149.177C579.869 147.774 578.504 146.579 576.963 145.645L577.889 141.907L572.06 139.881L570.502 143.413C568.706 143.211 566.888 143.325 565.131 143.749L563.127 140.498L557.679 143.185L559.074 146.783C557.669 147.908 556.467 149.264 555.522 150.791L551.763 149.871L549.78 155.635L553.31 157.13C553.107 158.916 553.222 160.724 553.648 162.471L550.379 164.465L553.081 169.882L556.699 168.495C557.831 169.896 559.199 171.091 560.741 172.028L559.804 175.766L565.523 177.781L567.092 174.249C568.885 174.445 570.699 174.331 572.453 173.913L574.457 177.217L579.959 174.53L578.597 170.933C580.007 169.802 581.202 168.43 582.127 166.881L585.897 167.813L587.869 162.049L584.317 160.489C584.52 158.706 584.406 156.901 583.98 155.158L587.313 153.197ZM573.074 167.455C571.357 168.29 569.43 168.6 567.536 168.346C565.642 168.091 563.866 167.284 562.434 166.026C561.001 164.769 559.975 163.117 559.487 161.28C558.998 159.442 559.068 157.502 559.688 155.704C560.308 153.907 561.449 152.332 562.969 151.18C564.489 150.027 566.318 149.349 568.225 149.23C570.132 149.111 572.032 149.557 573.685 150.512C575.337 151.467 576.667 152.888 577.508 154.594C578.068 155.728 578.397 156.961 578.477 158.221C578.557 159.482 578.387 160.745 577.975 161.94C577.563 163.135 576.918 164.237 576.077 165.183C575.236 166.13 574.215 166.902 573.074 167.455Z",
    fill: "#F89D13",
    style: {
      fill: "#F89D13",
      fill: "color(display-p3 0.9725 0.6157 0.0745)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54 164.421L627.303 162.146L620.614 159.979L617.498 163.446C615.531 162.585 613.431 162.064 611.288 161.908L610.198 157.379L603.661 156.154L602.909 158.43L603.182 163.078C601.145 163.828 599.257 164.928 597.603 166.328L593.616 163.879L589.955 167.498L589.193 169.774L592.69 172.872C591.795 174.848 591.253 176.963 591.088 179.124L587.297 177.91L586.534 180.186L587.624 187.456L592.298 187.185C593.073 189.212 594.198 191.089 595.621 192.732L593.856 194.466L593.093 196.73L599.02 201.14L602.136 197.662C604.121 198.553 606.249 199.089 608.422 199.244L609.512 203.784L616.833 202.7L617.585 200.436L616.561 198.052C618.595 197.298 620.483 196.198 622.139 194.802L626.072 197.218L630.495 191.335L631.258 189.059L626.998 188.236C627.895 186.257 628.437 184.138 628.6 181.974L633.154 180.89L633.916 178.626L632.097 173.62L627.423 173.891C626.664 171.868 625.559 169.991 624.154 168.343L626.54 164.421ZM619.143 187.521C617.761 189.358 615.862 190.746 613.686 191.51C611.511 192.275 609.156 192.38 606.921 191.814C604.685 191.248 602.668 190.035 601.125 188.329C599.582 186.624 598.582 184.501 598.252 182.23C597.922 179.96 598.276 177.642 599.269 175.572C600.263 173.501 601.851 171.769 603.834 170.596C605.817 169.423 608.105 168.861 610.409 168.981C612.713 169.1 614.93 169.897 616.779 171.269C618.01 172.178 619.049 173.321 619.837 174.63C620.624 175.94 621.144 177.391 621.366 178.901C621.589 180.41 621.51 181.948 621.134 183.428C620.758 184.907 620.093 186.298 619.175 187.521H619.143Z",
    fill: "#296ED3",
    style: {
      fill: "#296ED3",
      fill: "color(display-p3 0.1608 0.4314 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.338 162.147L621.411 157.748L618.295 161.226C616.306 160.333 614.174 159.794 611.998 159.633L610.908 155.104L603.598 156.188L603.87 160.836C601.833 161.586 599.945 162.686 598.292 164.087L594.315 161.627L589.892 167.521L593.378 170.62C592.488 172.597 591.95 174.712 591.787 176.872L587.233 177.955L588.323 185.236L592.997 184.965C593.751 186.99 594.857 188.868 596.265 190.512L593.858 194.467L599.784 198.866L602.9 195.388C604.885 196.283 607.013 196.822 609.187 196.981L610.2 201.553L617.51 200.47L617.238 195.822C619.274 195.07 621.162 193.97 622.816 192.571L626.793 195.02L631.227 189.126L627.73 186.027C628.63 184.054 629.169 181.937 629.321 179.775L633.886 178.692L632.796 171.422L628.122 171.682C627.363 169.662 626.257 167.788 624.854 166.145L627.338 162.147ZM619.929 185.301C618.547 187.138 616.648 188.526 614.473 189.29C612.297 190.055 609.943 190.16 607.707 189.594C605.471 189.028 603.454 187.815 601.911 186.109C600.368 184.404 599.369 182.281 599.038 180.01C598.708 177.74 599.062 175.422 600.055 173.352C601.049 171.281 602.638 169.55 604.62 168.376C606.603 167.203 608.891 166.641 611.195 166.761C613.499 166.88 615.716 167.677 617.565 169.049C618.794 169.961 619.83 171.105 620.614 172.416C621.399 173.726 621.915 175.178 622.135 176.688C622.354 178.197 622.273 179.735 621.894 181.213C621.516 182.691 620.848 184.08 619.929 185.301Z",
    fill: "#357DED",
    style: {
      fill: "#357DED",
      fill: "color(display-p3 0.2078 0.4902 0.9294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.154 184.239L373.274 182.751L373.913 181.268C376.122 176.568 379.759 172.677 384.311 170.141L385.429 169.566L383.308 171.059L382.191 171.634C377.148 174.435 373.245 178.896 371.153 184.249M415.571 179.812L417.692 178.319L419.196 167.709L417.075 169.202L415.571 179.812ZM428.761 166.889C427.851 165.789 427.033 164.794 426.011 163.753C413.644 150.932 393.749 147.311 378.097 156.129C379.375 155.615 380.527 155.142 381.85 154.722C389.483 152.3 397.662 152.15 405.38 154.289C413.099 156.429 420.02 160.766 425.292 166.765L426.62 168.374L427.524 169.526L429.639 168.032L428.761 166.889Z",
    fill: "#C3E4D4",
    style: {
      fill: "#C3E4D4",
      fill: "color(display-p3 0.7647 0.8941 0.8314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.618 213.897L410.738 212.409C407.991 214.284 404.892 215.588 401.626 216.244L401.272 216.315L399.152 217.803C402.548 217.175 405.773 215.844 408.618 213.897ZM474.091 183.315L476.211 181.827L478.641 172.485L467.899 168.447L465.784 169.941L476.52 173.978L474.091 183.315Z",
    fill: "#DA9114",
    style: {
      fill: "#DA9114",
      fill: "color(display-p3 0.8567 0.5667 0.0783)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.639 218.945L459.879 218.638L457.759 220.131L467.519 220.439C468.573 221.715 469.748 222.887 471.029 223.938C475.864 227.861 481.992 229.858 488.224 229.541C494.456 229.225 500.348 226.619 504.757 222.227L505.074 221.907L507.195 220.414C502.651 225.158 496.399 227.914 489.813 228.078C486.185 228.181 482.577 227.503 479.237 226.092C475.896 224.68 472.902 222.568 470.457 219.899L469.639 218.945ZM517.713 231.437C521.885 228.505 524.441 224.053 526.48 219.465L516.661 221.991L512.655 211.48L510.535 212.968L514.541 223.484L524.354 220.953L523.576 222.631C522.018 225.809 520.047 228.77 517.713 231.437Z",
    fill: "#C3E4D4",
    style: {
      fill: "#C3E4D4",
      fill: "color(display-p3 0.7647 0.8941 0.8314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.404 218.308L527.524 216.82L528.292 214.423C530.455 206.965 530.423 199.047 528.199 191.607C525.975 184.167 521.652 177.517 515.744 172.445C509.836 167.373 502.589 164.092 494.863 162.991C487.137 161.89 479.256 163.015 472.153 166.232L470.545 167.003L468.425 168.491C470.017 167.701 471.655 167.005 473.329 166.408C480.502 163.877 488.244 163.392 495.68 165.008C503.116 166.623 509.949 170.274 515.408 175.549C520.867 180.823 524.734 187.511 526.572 194.856C528.409 202.201 528.145 209.911 525.808 217.115L525.404 218.308Z",
    fill: "#236CD8",
    style: {
      fill: "#236CD8",
      fill: "color(display-p3 0.1373 0.4235 0.8471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.663 218.084L467.783 216.596L453.813 198.813L451.774 200.405L465.663 218.084ZM454.173 228.984L456.293 227.496L457.883 216.282L455.762 217.775L454.173 228.984ZM431.513 170.379L421.191 170.05L419.07 171.543L429.393 171.867L442.041 187.985L444.09 186.399L431.513 170.379Z",
    fill: "#C3E4D4",
    style: {
      fill: "#C3E4D4",
      fill: "color(display-p3 0.7647 0.8941 0.8314)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.581 232.698L406.701 231.21L409.386 222.211L396.338 216.741C391.914 216.701 387.577 215.507 383.763 213.279C379.156 210.569 375.547 206.457 373.47 201.552C371.393 196.646 370.957 191.206 372.227 186.035L372.407 185.344L363.22 187.713L358.886 176.257L356.765 177.75L361.125 189.21L370.312 186.84C370.211 186.979 369.781 189.262 369.726 189.619C369.179 193.089 369.379 196.634 370.313 200.021C371.247 203.408 372.895 206.558 375.146 209.264C377.398 211.969 380.202 214.168 383.372 215.715C386.543 217.261 390.008 218.12 393.537 218.234L394.231 218.246L407.285 223.717L404.581 232.698Z",
    fill: "#236CD8",
    style: {
      fill: "#236CD8",
      fill: "color(display-p3 0.1373 0.4235 0.8471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.019 173.716C384.269 169.678 390.91 167.866 397.496 168.673C404.083 169.481 410.082 172.844 414.187 178.029L415.574 179.796L417.078 169.186L427.552 169.518L426.648 168.367C422.43 162.982 416.915 158.742 410.613 156.039C404.31 153.335 397.424 152.256 390.591 152.901C383.759 153.545 377.199 155.893 371.521 159.727C365.842 163.561 361.227 168.757 358.103 174.834L362.534 186.469L371.18 184.246C372.799 180.098 375.517 176.462 379.045 173.724",
    fill: "#DCFDEC",
    style: {
      fill: "#DCFDEC",
      fill: "color(display-p3 0.8617 0.9923 0.9270)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.683 208.69C372.298 205.633 370.66 202.066 369.899 198.271C369.139 194.476 369.277 190.557 370.301 186.824L361.115 189.193L356.755 177.734C353.824 184.702 352.906 192.345 354.104 199.804C355.303 207.262 358.572 214.24 363.542 219.952C368.512 225.664 374.986 229.883 382.236 232.135C389.486 234.387 397.224 234.581 404.579 232.697L407.264 223.699L394.211 218.228C390.441 218.202 386.725 217.331 383.341 215.679C379.956 214.028 376.99 211.638 374.663 208.688",
    fill: "#357DED",
    style: {
      fill: "#357DED",
      fill: "color(display-p3 0.2078 0.4902 0.9294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.325 210.063L454.174 228.984L455.763 217.775L465.664 218.084L451.782 200.39L439.325 210.063Z",
    fill: "#DCFDEC",
    style: {
      fill: "#DCFDEC",
      fill: "color(display-p3 0.8617 0.9923 0.9270)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.061 188.008L429.394 171.867L419.072 171.543L417.544 182.306L429.605 197.675L442.061 188.008Z",
    fill: "#DCFDEC",
    style: {
      fill: "#DCFDEC",
      fill: "color(display-p3 0.8617 0.9923 0.9270)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.842 181.91C481.001 180.078 485.584 179.409 490.097 179.975C494.61 180.541 498.882 182.321 502.453 185.123C506.024 187.924 508.758 191.642 510.362 195.875C511.966 200.109 512.377 204.697 511.553 209.145L515.971 220.763L525.402 218.33C528.148 210.674 528.521 202.376 526.471 194.508C524.422 186.639 520.045 179.564 513.907 174.197C507.769 168.831 500.152 165.42 492.043 164.406C483.934 163.392 475.706 164.823 468.423 168.512L479.268 172.594L476.842 181.91Z",
    fill: "#357DED",
    style: {
      fill: "#357DED",
      fill: "color(display-p3 0.2078 0.4902 0.9294)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.365 224.348C497.185 228.329 490.65 230.147 484.144 229.418C477.639 228.688 471.676 225.467 467.518 220.439L457.779 220.134L456.176 231.414C463.066 239.212 472.687 244.104 483.078 245.093C493.469 246.082 503.849 243.094 512.101 236.738C517.461 232.585 521.685 227.158 524.385 220.957L514.571 223.489L510.545 212.97C508.978 217.468 506.137 221.419 502.365 224.348Z",
    fill: "#DCFDEC",
    style: {
      fill: "#DCFDEC",
      fill: "color(display-p3 0.8617 0.9923 0.9270)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.571 225.39L439.32 210.062L451.775 200.404L471.542 185.063C472.357 184.419 473.213 183.829 474.105 183.296L476.532 173.969L465.796 169.932C464.41 170.758 463.074 171.666 461.797 172.651L442.043 187.979L429.598 197.684L409.849 213.002C406.722 215.432 403.054 217.079 399.153 217.803L410.093 222.386L407.221 231.918C411.691 230.465 415.873 228.25 419.578 225.37",
    fill: "#FFA000",
    style: {
      fill: "#FFA000",
      fill: "color(display-p3 1.0000 0.6275 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_11499_163943",
    x: 453.816,
    y: 630.712,
    width: 224.046,
    height: 224.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.9805,
    dy: 10.9805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.49023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11499_163943"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.9805,
    dy: -10.9805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.49023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11499_163943",
    result: "effect2_innerShadow_11499_163943"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11499_163943_clip_path",
    transform: "translate(-453.816 -630.712)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 565.839,
    cy: 742.736,
    r: 82.3535,
    transform: "rotate(18.5062 565.839 742.736)"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_11499_163943",
    x: 33.8391,
    y: 226.315,
    width: 177.283,
    height: 177.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.6888,
    dy: 8.6888
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11499_163943"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.6888,
    dy: -8.6888
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11499_163943",
    result: "effect2_innerShadow_11499_163943"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_11499_163943_clip_path",
    transform: "translate(-33.8391 -226.315)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122.481,
    cy: 314.957,
    r: 65.166,
    transform: "rotate(-14.4831 122.481 314.957)"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_11499_163943",
    x: 103.251,
    y: 707.649,
    width: 140.804,
    height: 140.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6.90169,
    dy: 6.90169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11499_163943"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.90169,
    dy: -6.90169
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11499_163943",
    result: "effect2_innerShadow_11499_163943"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_11499_163943_clip_path",
    transform: "translate(-103.251 -707.649)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.653,
    cy: 778.051,
    r: 51.7627,
    transform: "rotate(-6.96315 173.653 778.051)"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_11499_163943",
    x: 284.315,
    y: 816.72,
    width: 189.442,
    height: 188.914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.96335,
    dy: 8.96335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.48168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11499_163943"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.96335,
    dy: -8.96335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.48168
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11499_163943",
    result: "effect2_innerShadow_11499_163943"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_5_11499_163943_clip_path",
    transform: "translate(-284.315 -816.72)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.301,
    y: 872.277,
    width: 120.812,
    height: 120,
    rx: 20.4075,
    transform: "rotate(-17.6206 303.301 872.277)"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_11499_163943",
    x: 281.845,
    y: 61.6379,
    width: 408.272,
    height: 262.136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.9805,
    dy: 10.9805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.49023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11499_163943"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.9805,
    dy: -10.9805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.49023
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0 0.646745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11499_163943",
    result: "effect2_innerShadow_11499_163943"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_7_11499_163943_clip_path",
    transform: "translate(-281.845 -61.6379)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.266,
    y: 88.416,
    width: 336.605,
    height: 168.647,
    rx: 25,
    transform: "rotate(7.03084 329.266 88.416)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11499_163943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.7356,
    height: 81.7356,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(71.5312 284.707) rotate(-14.4831)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11499_163943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.9931,
    height: 56.9931,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(142.171 755.341) rotate(-6.96315)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11499_163943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.0444,
    height: 73.0444,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(335.171 887.423) rotate(-17.6206)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/signIn.c5ffdc958dfd466388b3b88834cd123e.svg";
export { ForwardRef as ReactComponent };